import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Date custom scalar type */
  Date: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type AddCodeInput = {
  code: Scalars['String'];
};

export type AddPlayerCodeInput = {
  code: Scalars['String'];
};

export type AddTrainerCodeInput = {
  code: Scalars['String'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
};

export type CancelReleasedPlayerScoreInput = {
  playerSessionId: Scalars['Int'];
  sessionNumber: Scalars['Int'];
};

export type CancelReleasedPlayerScoreOutput = {
  __typename?: 'CancelReleasedPlayerScoreOutput';
  playerSessionId: Scalars['Int'];
  sessionNumber: Scalars['Int'];
};

export type Card = {
  cvc: Scalars['String'];
  expMonth: Scalars['Int'];
  expYear: Scalars['Int'];
  number: Scalars['String'];
};

export type CheckEmailExistInput = {
  email: Scalars['String'];
};

export type CheckEmailExistOutput = {
  __typename?: 'CheckEmailExistOutput';
  email: Scalars['String'];
  exist: Scalars['Boolean'];
};

export type CheckEmailTokenInput = {
  sub: Scalars['String'];
  type: Scalars['String'];
  uuid: Scalars['String'];
};

export type CheckEmailTokenOutput = {
  __typename?: 'CheckEmailTokenOutput';
  sub: Scalars['String'];
  tokenValid: Scalars['Boolean'];
  type: Scalars['String'];
  user: User;
  uuid: Scalars['String'];
};

export type CheckUsernameExistInput = {
  username: Scalars['String'];
};

export type CheckUsernameExistOutput = {
  __typename?: 'CheckUsernameExistOutput';
  exist: Scalars['Boolean'];
  username: Scalars['String'];
};

export type Club = {
  __typename?: 'Club';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  logoUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Int']>;
  street?: Maybe<Scalars['String']>;
};

export type CompareInput = {
  role: UserRole;
  sessionNumber?: InputMaybe<Scalars['Int']>;
  sub?: InputMaybe<Scalars['String']>;
  subFrom?: InputMaybe<Scalars['String']>;
  type: FoundComparisonType;
};

export type Comparison = {
  __typename?: 'Comparison';
  compareA: ComparisonScore;
  compareB: ComparisonScore;
  difference: Array<SubScores>;
  playerSessionId?: Maybe<Scalars['Int']>;
  role: UserRole;
  sessionNumber?: Maybe<Scalars['Int']>;
  type: ComparisonType;
};

export type ComparisonOptions = {
  __typename?: 'ComparisonOptions';
  compareFrom?: Maybe<WatchComparisonResult>;
  players: Array<Player>;
  previous?: Maybe<Array<PreviousSession>>;
  team?: Maybe<Club>;
};

export type ComparisonScore = {
  __typename?: 'ComparisonScore';
  avatar?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
  name?: Maybe<Scalars['String']>;
  subScores: Array<SubScores>;
};

export enum ComparisonSelected {
  Player = 'Player',
  Team = 'Team'
}

export enum ComparisonType {
  Me = 'ME',
  Team = 'TEAM',
  TeamPlayer = 'TEAM_PLAYER',
  Youth = 'YOUTH'
}

export type ConfirmLegalGuardianInput = {
  birthdate: SeparatedDateInput;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  token: Scalars['String'];
};

export type ConfirmLegalGuardianOutput = {
  __typename?: 'ConfirmLegalGuardianOutput';
  confirmed: Scalars['Boolean'];
  user: User;
};

export type ConfirmUserEmailInput = {
  token: Scalars['String'];
};

export type ConfirmUserEmailOutput = {
  __typename?: 'ConfirmUserEmailOutput';
  user: User;
};

export type CreateClubInput = {
  name: Scalars['String'];
};

export type CreateOperatorSessionInput = {
  ageGroup: Scalars['String'];
  clubId: Scalars['Int'];
  fixedGoalkeepers?: InputMaybe<Scalars['Boolean']>;
  geolocation?: InputMaybe<GeoLocation>;
  ground?: InputMaybe<GroundInput>;
  playerCodes: Array<Scalars['String']>;
  shotTest?: InputMaybe<Scalars['Boolean']>;
  sprintTest?: InputMaybe<Scalars['Boolean']>;
  trainerCodes: Array<Scalars['String']>;
};

export type CreateOperatorSessionOutput = {
  __typename?: 'CreateOperatorSessionOutput';
  created: Scalars['Boolean'];
  sessionNumber: Scalars['Int'];
};

export type CreateScoutingEventInput = {
  clubId: Scalars['Int'];
  end: Scalars['Date'];
  externalSources?: InputMaybe<Array<Scalars['String']>>;
  fixedGoalKeepers?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  playerIds?: InputMaybe<Array<Scalars['String']>>;
  shotTest?: InputMaybe<Scalars['Boolean']>;
  sprintTest?: InputMaybe<Scalars['Boolean']>;
  start: Scalars['Date'];
  trainerIds?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateStripeIntentInput = {
  playerSessionId: Scalars['Int'];
  sessionNumber: Scalars['Int'];
};

export type CreateStripeIntentOutput = {
  __typename?: 'CreateStripeIntentOutput';
  clientSecret: Scalars['String'];
  fresh: Scalars['Boolean'];
  pubKey: Scalars['String'];
  stripeId: Scalars['String'];
};

export type DeleteAccountInput = {
  password: Scalars['String'];
};

export type DeleteAccountOutput = {
  __typename?: 'DeleteAccountOutput';
  deleted: Scalars['Boolean'];
  sub: Scalars['String'];
};

export type DeleteOperatorSessionOutput = {
  __typename?: 'DeleteOperatorSessionOutput';
  deleted: Scalars['Boolean'];
  sessionNumber: Scalars['Int'];
};

export type EventPlayer = {
  __typename?: 'EventPlayer';
  inSession: Scalars['Boolean'];
  player: User;
};

export type FindComparisonInput = {
  playerSessionId?: InputMaybe<Scalars['Int']>;
  role: UserRole;
  sessionNumber?: InputMaybe<Scalars['Int']>;
  type: ComparisonType;
};

export type FindComparisonOptionsInput = {
  role: UserRole;
  selected?: InputMaybe<ComparisonSelected>;
  subFrom?: InputMaybe<Scalars['String']>;
};

export type FindVideosOutput = {
  __typename?: 'FindVideosOutput';
  date: Scalars['Date'];
  playerSessionId?: Maybe<Scalars['Int']>;
  sessionNumber: Scalars['Int'];
  videos: Array<VideoTumb>;
};

export type ForgotPasswordInput = {
  email: Scalars['String'];
  username: Scalars['String'];
};

export type ForgotPasswordOutput = {
  __typename?: 'ForgotPasswordOutput';
  email: Scalars['String'];
  emailSent: Scalars['Boolean'];
};

export type ForgotUserPasswordInput = {
  usernameOrEmail: Scalars['String'];
};

export type ForgotUserPasswordOutput = {
  __typename?: 'ForgotUserPasswordOutput';
  email: Scalars['String'];
  emailSent: Scalars['Boolean'];
};

export type FoundComparison = {
  __typename?: 'FoundComparison';
  compareFrom?: Maybe<FoundComparisonScore>;
  compareTo?: Maybe<FoundComparisonScore>;
  difference?: Maybe<Array<SubScores>>;
  role: UserRole;
  sessionNumber?: Maybe<Scalars['Int']>;
  sub?: Maybe<Scalars['String']>;
  subFrom?: Maybe<Scalars['String']>;
  type: FoundComparisonType;
};

export type FoundComparisonScore = {
  __typename?: 'FoundComparisonScore';
  avatar?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
  name?: Maybe<Scalars['String']>;
  sessionNumber: Scalars['Int'];
  subScores?: Maybe<Array<SubScores>>;
};

export enum FoundComparisonType {
  PlayerVsPlayer = 'PlayerVsPlayer',
  PlayerVsPrev = 'PlayerVsPrev',
  PlayerVsTeam = 'PlayerVsTeam',
  SelectedPlayerVsPlayer = 'SelectedPlayerVsPlayer',
  SelectedPlayerVsPrev = 'SelectedPlayerVsPrev',
  SelectedPlayerVsTeam = 'SelectedPlayerVsTeam',
  TeamVsPlayer = 'TeamVsPlayer',
  TeamVsPrev = 'TeamVsPrev'
}

export type GeoLocation = {
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
};

export type GetEmailVerificationTokenInput = {
  email: Scalars['String'];
};

export type GetEmailVerificationTokenOutput = {
  __typename?: 'GetEmailVerificationTokenOutput';
  email: Scalars['String'];
  expiredIn?: Maybe<Scalars['Date']>;
  sub: Scalars['String'];
  type: Scalars['String'];
  uuid?: Maybe<Scalars['String']>;
};

export type Ground = {
  __typename?: 'Ground';
  goalHeight?: Maybe<Scalars['Float']>;
  goalWidth?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export type GroundInput = {
  goalHeight?: InputMaybe<Scalars['Float']>;
  goalWidth?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type ImpersonateInput = {
  email: Scalars['String'];
  sub: Scalars['String'];
};

export type LegalGuardian = {
  __typename?: 'LegalGuardian';
  birthdate?: Maybe<SeparatedDate>;
  consent: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type LegalGuardianInput = {
  birthdate: SeparatedDateInput;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
};

export type LegalGuardianSignUpInput = {
  birthdate?: InputMaybe<SeparatedDateInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type LogoutInput = {
  refreshToken: Scalars['String'];
};

export type LogoutOutput = {
  __typename?: 'LogoutOutput';
  logout: Scalars['Boolean'];
  sub: Scalars['String'];
};

export type Match = {
  players: Array<PlayerGoals>;
};

export type Mutation = {
  __typename?: 'Mutation';
  UpdateEventSession: OperatorSession;
  addCode: SessionOrScore;
  addPlayerCode: Score;
  addTrainerCode: Session;
  cancelReleasedPlayerScore: CancelReleasedPlayerScoreOutput;
  confirmLegalGuardian: ConfirmLegalGuardianOutput;
  confirmUserEmail: ConfirmUserEmailOutput;
  createClub: Club;
  createEvent: ScoutingEvent;
  createEventSession: OperatorSession;
  createOperatorSession: CreateOperatorSessionOutput;
  createStripeIntent: CreateStripeIntentOutput;
  createWatchComparison: WatchComparison;
  createWatchSession: WatchSession;
  deleteAccount: DeleteAccountOutput;
  deleteEvent: Scalars['Boolean'];
  deleteEventSession: Scalars['Boolean'];
  deleteOperatorSession: DeleteOperatorSessionOutput;
  deleteUser: Scalars['Boolean'];
  deleteWatchComparison: WatchComparisonDeletedOutput;
  deleteWatchSession: WatchSessionDeletedOutput;
  forgotPassword: ForgotPasswordOutput;
  forgotUserPassword: ForgotUserPasswordOutput;
  impersonate: SignInOutput;
  logout: LogoutOutput;
  payPlayerSessionWithCard: PayPlayerSessionWithCardOutput;
  payPlayerSessionWithPaypal: PayPlayerSessionWithPaypalOutput;
  processOperatorSession: ProcessOperatorSessionOutput;
  refreshToken: RefreshTokenOutput;
  releasePlayerScore: ReleasePlayerScoreOutput;
  resendExpiredLink: ResendExpiredLinkOutput;
  resendLegalGuardianEmail: ResendLegalGuardianEmailOutput;
  resendUserEmail: ResendUserEmailOutput;
  resetPassword: ResetPasswordOutput;
  resetUserPassword: ResetUserPasswordOutput;
  signIn: SignInOutput;
  signUp: SignUpOutput;
  signin: SignInOutput;
  signup: SignUpOutput;
  updateEvent: ScoutingEvent;
  updateOperatorSession: UpdateOperatorSessionOutput;
  updateUser: UpdateUserOutput;
  updateUserAvatar: UpdateUserAvatarOutput;
  updateUserBackground: UpdateUserBackgroundOutput;
  updateUserById: UpdateUserOutput;
  updateUserPassword: UpdateUserPasswordOutput;
  uploadSessionVideo: UploadSessionVideoOutput;
  verifyLegalGuardian: VerifyLegalGuardianOutput;
  verifyUserEmail: VerifyUserEmailOutput;
};


export type MutationUpdateEventSessionArgs = {
  eventNumber: Scalars['Int'];
  session: UpdateOperatorSessionInput;
};


export type MutationAddCodeArgs = {
  addCodeInput: AddCodeInput;
};


export type MutationAddPlayerCodeArgs = {
  addPlayerCodeInput: AddPlayerCodeInput;
};


export type MutationAddTrainerCodeArgs = {
  addTrainerCodeInput: AddTrainerCodeInput;
};


export type MutationCancelReleasedPlayerScoreArgs = {
  cancelReleasedPlayerScoreInput: CancelReleasedPlayerScoreInput;
};


export type MutationConfirmLegalGuardianArgs = {
  confirmLegalGuardianInput: ConfirmLegalGuardianInput;
};


export type MutationConfirmUserEmailArgs = {
  confirmUserEmailInput: ConfirmUserEmailInput;
};


export type MutationCreateClubArgs = {
  createClubInput: CreateClubInput;
};


export type MutationCreateEventArgs = {
  createScoutingEventInput: CreateScoutingEventInput;
};


export type MutationCreateEventSessionArgs = {
  args: CreateOperatorSessionInput;
  eventNumber: Scalars['Int'];
};


export type MutationCreateOperatorSessionArgs = {
  createOperatorSessionInput: CreateOperatorSessionInput;
};


export type MutationCreateStripeIntentArgs = {
  createStripeIntentInput: CreateStripeIntentInput;
};


export type MutationCreateWatchComparisonArgs = {
  createWatchComparisonInput: WatchComparisonInput;
};


export type MutationCreateWatchSessionArgs = {
  createWatchSessionInput: WatchSessionInput;
};


export type MutationDeleteAccountArgs = {
  deleteAccountInput: DeleteAccountInput;
};


export type MutationDeleteEventArgs = {
  eventNumber: Scalars['Int'];
};


export type MutationDeleteEventSessionArgs = {
  eventNumber: Scalars['Int'];
  sessionNumber: Scalars['Int'];
};


export type MutationDeleteOperatorSessionArgs = {
  sessionNumber: Scalars['Int'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['String'];
};


export type MutationDeleteWatchComparisonArgs = {
  deleteWatchComparisonInput: WatchComparisonInput;
};


export type MutationDeleteWatchSessionArgs = {
  deleteWatchSessionInput: WatchSessionInput;
};


export type MutationForgotPasswordArgs = {
  forgotPasswordInput: ForgotPasswordInput;
};


export type MutationForgotUserPasswordArgs = {
  forgotUserPasswordInput: ForgotUserPasswordInput;
};


export type MutationImpersonateArgs = {
  impersonateInput: ImpersonateInput;
};


export type MutationLogoutArgs = {
  logoutInput: LogoutInput;
};


export type MutationPayPlayerSessionWithCardArgs = {
  payPlayerSessionWithCardInput: PayPlayerSessionWithCardInput;
};


export type MutationPayPlayerSessionWithPaypalArgs = {
  payPlayerSessionWithPaypalInput: PayPlayerSessionWithPaypalInput;
};


export type MutationProcessOperatorSessionArgs = {
  processOperatorSessionInput: ProcessOperatorSessionInput;
};


export type MutationRefreshTokenArgs = {
  refreshTokenInput: RefreshTokenInput;
};


export type MutationReleasePlayerScoreArgs = {
  releasePlayerScoreInput: ReleasePlayerScoreInput;
};


export type MutationResendExpiredLinkArgs = {
  resendExpiredLinkInput: ResendExpiredLinkInput;
};


export type MutationResendLegalGuardianEmailArgs = {
  resendLegalGuardianEmailInput: ResendLegalGuardianEmailInput;
};


export type MutationResendUserEmailArgs = {
  resendUserEmailInput: ResendUserEmailInput;
};


export type MutationResetPasswordArgs = {
  resetPasswordInput: ResetPasswordInput;
};


export type MutationResetUserPasswordArgs = {
  resetUserPasswordInput: ResetUserPasswordInput;
};


export type MutationSignInArgs = {
  signInInput: SignInInput;
};


export type MutationSignUpArgs = {
  signUpInput: SignUpInput;
};


export type MutationSigninArgs = {
  signInInput: SignInInput;
};


export type MutationSignupArgs = {
  signUpInput: SignUpInput;
};


export type MutationUpdateEventArgs = {
  updateScoutingEventInput: UpdateScoutingEventInput;
};


export type MutationUpdateOperatorSessionArgs = {
  updateOperatorSessionInput: UpdateOperatorSessionInput;
};


export type MutationUpdateUserArgs = {
  updateUserInput: UpdateUserInput;
};


export type MutationUpdateUserAvatarArgs = {
  file: Scalars['Upload'];
};


export type MutationUpdateUserBackgroundArgs = {
  file: Scalars['Upload'];
};


export type MutationUpdateUserByIdArgs = {
  updateUserByIdInput: UpdateUserByIdInput;
};


export type MutationUpdateUserPasswordArgs = {
  updateUserPasswordInput: UpdateUserPasswordInput;
};


export type MutationUploadSessionVideoArgs = {
  file: Scalars['Upload'];
  sessionNumber: Scalars['Int'];
  videoType: Scalars['String'];
};


export type MutationVerifyLegalGuardianArgs = {
  verifyLegalGuardianInput: VerifyLegalGuardianInput;
};


export type MutationVerifyUserEmailArgs = {
  verifyUserEmailInput: VerifyUserEmailInput;
};

export enum NotificationKey {
  Button = 'Button',
  ButtonUrl = 'ButtonUrl',
  Icon = 'Icon',
  Link = 'Link',
  Url = 'Url'
}

export enum NotificationType {
  AvatarRequired = 'AvatarRequired',
  BackgroundRecomended = 'BackgroundRecomended',
  EmailRequired = 'EmailRequired',
  LegalGuardianRequired = 'LegalGuardianRequired',
  NoSessionPlayer = 'NoSessionPlayer',
  NoSessionTrainer = 'NoSessionTrainer',
  SelfAssessment = 'SelfAssessment'
}

export type NotificationsOutput = {
  __typename?: 'NotificationsOutput';
  minAppVersion: Scalars['String'];
  notificationList: Array<SystemNotification>;
  unreadCount: Scalars['Int'];
};

export type OperatorSession = {
  __typename?: 'OperatorSession';
  ageGroup: Scalars['String'];
  allVideosUploaded: Scalars['Boolean'];
  club: Club;
  date: Scalars['Date'];
  fixedGoalkeepers: Scalars['Boolean'];
  ground?: Maybe<Ground>;
  matchesCount: Scalars['Int'];
  playersCount: Scalars['Int'];
  processed: Scalars['Boolean'];
  scored: Scalars['Boolean'];
  sessionNumber: Scalars['Int'];
  shotTest: Scalars['Boolean'];
  sprintTest: Scalars['Boolean'];
  trainersCount: Scalars['Int'];
  videosUploaded: Array<Scalars['String']>;
};

export enum Order {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type PaginatedUsersInput = {
  order?: InputMaybe<UserOrder>;
  roles?: InputMaybe<Array<UserRole>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take: Scalars['Int'];
};

export type PaginatedUsersOutput = {
  __typename?: 'PaginatedUsersOutput';
  count: Scalars['Float'];
  result: Array<User>;
  skip: Scalars['Float'];
  take: Scalars['Float'];
};

export type PartialOperatorSession = {
  __typename?: 'PartialOperatorSession';
  ageGroup?: Maybe<Scalars['String']>;
  allVideosUploaded?: Maybe<Scalars['Boolean']>;
  club?: Maybe<Club>;
  date?: Maybe<Scalars['Date']>;
  fixedGoalkeepers?: Maybe<Scalars['Boolean']>;
  ground?: Maybe<Ground>;
  matchesCount?: Maybe<Scalars['Int']>;
  playersCount?: Maybe<Scalars['Int']>;
  processed?: Maybe<Scalars['Boolean']>;
  scored?: Maybe<Scalars['Boolean']>;
  sessionNumber?: Maybe<Scalars['Int']>;
  shotTest?: Maybe<Scalars['Boolean']>;
  sprintTest?: Maybe<Scalars['Boolean']>;
  trainersCount?: Maybe<Scalars['Int']>;
  videosUploaded?: Maybe<Array<Scalars['String']>>;
};

export type PayPlayerSessionWithCardInput = {
  card: Card;
  email: Scalars['String'];
  name: Scalars['String'];
  paymentType?: InputMaybe<Scalars['Int']>;
  playerSessionId: Scalars['Int'];
  sessionNumber: Scalars['Int'];
};

export type PayPlayerSessionWithCardOutput = {
  __typename?: 'PayPlayerSessionWithCardOutput';
  paidAt: Scalars['Date'];
  playerSessionId: Scalars['Int'];
  sessionNumber: Scalars['Int'];
};

export type PayPlayerSessionWithPaypalInput = {
  orderId: Scalars['String'];
  payerID: Scalars['String'];
  playerSessionId: Scalars['Int'];
  sessionNumber: Scalars['Int'];
};

export type PayPlayerSessionWithPaypalOutput = {
  __typename?: 'PayPlayerSessionWithPaypalOutput';
  paidAt: Scalars['Date'];
  playerSessionId: Scalars['Int'];
  sessionNumber: Scalars['Int'];
};

export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  amount?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  paidAt?: Maybe<Scalars['Date']>;
};

export type Player = {
  __typename?: 'Player';
  avatarUrl?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  playerSessionId: Scalars['Int'];
  released: Scalars['Boolean'];
  score?: Maybe<Scalars['Float']>;
  sessionNumber: Scalars['Int'];
  userId?: Maybe<Scalars['String']>;
};

export type PlayerGoals = {
  goals: Scalars['Int'];
  playerSessionId: Scalars['Int'];
};

export type PreviousSession = {
  __typename?: 'PreviousSession';
  avatar?: Maybe<Scalars['String']>;
  date: Scalars['Date'];
  released: Scalars['Boolean'];
  sessionNumber: Scalars['Int'];
  value?: Maybe<Scalars['Int']>;
};

export type ProcessOperatorSessionInput = {
  matches?: InputMaybe<Array<Match>>;
  sessionNumber: Scalars['Int'];
};

export type ProcessOperatorSessionOutput = {
  __typename?: 'ProcessOperatorSessionOutput';
  processed: Scalars['Boolean'];
  sessionNumber: Scalars['Int'];
};

export type Query = {
  __typename?: 'Query';
  checkEmailExist: CheckEmailExistOutput;
  checkEmailExists: CheckEmailExistOutput;
  checkEmailToken: CheckEmailTokenOutput;
  checkUserNameExist: CheckUsernameExistOutput;
  clubs: Array<Club>;
  compare?: Maybe<FoundComparison>;
  findComparison?: Maybe<Comparison>;
  findComparisonOptions?: Maybe<ComparisonOptions>;
  findEventPlayer: Array<EventPlayer>;
  findEventTrainer: Array<User>;
  findOperatorSessionById?: Maybe<OperatorSession>;
  findPlayerScore?: Maybe<Score>;
  findPlayerScoresByUserId: Array<Score>;
  findPlayers?: Maybe<Array<Player>>;
  findSession?: Maybe<Session>;
  findSessionsByUserId: Array<Session>;
  findVideo?: Maybe<Video>;
  findVideos: Array<FindVideosOutput>;
  getEmailVerificationToken: GetEmailVerificationTokenOutput;
  getEvent: ScoutingEvent;
  getEventSession: OperatorSession;
  getTrainingVideos: Array<SubScoreTrainingVideos>;
  listEventSessions: Array<OperatorSession>;
  listEvents: Array<ScoutingEvent>;
  notificationKeys: Array<NotificationKey>;
  notificationTypes: Array<NotificationType>;
  notifications: NotificationsOutput;
  operatorSessions: Array<OperatorSession>;
  paginatedUsers: PaginatedUsersOutput;
  playerScores: Array<Score>;
  searchPlayers: Array<User>;
  searchTrainers: Array<User>;
  searchUsers: Array<User>;
  sessions: Array<Session>;
  user: User;
  users: Array<User>;
  validateCode: ValidateCodeOutput;
  validateEmail: ValidateEmailOutput;
  watchComparisons: Array<WatchComparison>;
  watchSessions: Array<WatchSession>;
};


export type QueryCheckEmailExistArgs = {
  input: CheckEmailExistInput;
};


export type QueryCheckEmailExistsArgs = {
  input: CheckEmailExistInput;
};


export type QueryCheckEmailTokenArgs = {
  checkEmailTokenInput: CheckEmailTokenInput;
};


export type QueryCheckUserNameExistArgs = {
  input: CheckUsernameExistInput;
};


export type QueryClubsArgs = {
  name?: InputMaybe<Scalars['String']>;
};


export type QueryCompareArgs = {
  compareInput: CompareInput;
};


export type QueryFindComparisonArgs = {
  findComparisonInput: FindComparisonInput;
};


export type QueryFindComparisonOptionsArgs = {
  findComparisonOptionsInput: FindComparisonOptionsInput;
};


export type QueryFindEventPlayerArgs = {
  eventNumber: Scalars['Int'];
  search: Scalars['String'];
};


export type QueryFindEventTrainerArgs = {
  eventNumber: Scalars['Int'];
  search: Scalars['String'];
};


export type QueryFindOperatorSessionByIdArgs = {
  sessionNumber: Scalars['Int'];
};


export type QueryFindPlayerScoreArgs = {
  playerSessionId: Scalars['Int'];
  sessionNumber: Scalars['Int'];
};


export type QueryFindPlayerScoresByUserIdArgs = {
  userId: Scalars['String'];
};


export type QueryFindPlayersArgs = {
  sessionNumber: Scalars['Int'];
};


export type QueryFindSessionArgs = {
  sessionNumber: Scalars['Int'];
};


export type QueryFindSessionsByUserIdArgs = {
  id: Scalars['String'];
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryFindVideoArgs = {
  id: Scalars['String'];
  playerSessionId?: InputMaybe<Scalars['Int']>;
  sessionNumber: Scalars['Int'];
};


export type QueryFindVideosArgs = {
  role: UserRole;
};


export type QueryGetEmailVerificationTokenArgs = {
  getEmailVerificationTokenInput: GetEmailVerificationTokenInput;
};


export type QueryGetEventArgs = {
  eventNumber: Scalars['Int'];
};


export type QueryGetEventSessionArgs = {
  eventNumber: Scalars['Int'];
  sessionNumber: Scalars['Int'];
};


export type QueryGetTrainingVideosArgs = {
  playerSessionId: Scalars['Int'];
  sessionNumber: Scalars['Int'];
};


export type QueryListEventSessionsArgs = {
  eventNumber: Scalars['Int'];
};


export type QueryPaginatedUsersArgs = {
  paginatedUsersInput: PaginatedUsersInput;
};


export type QueryPlayerScoresArgs = {
  take?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchPlayersArgs = {
  externalSource: Scalars['String'];
};


export type QuerySearchTrainersArgs = {
  externalSource: Scalars['String'];
};


export type QuerySearchUsersArgs = {
  externalSource: Scalars['String'];
  roles: Array<Scalars['String']>;
};


export type QuerySessionsArgs = {
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryValidateCodeArgs = {
  code: Scalars['String'];
};


export type QueryValidateEmailArgs = {
  validateEmailInput: ValidateEmailInput;
};


export type QueryWatchComparisonsArgs = {
  role: UserRole;
};


export type QueryWatchSessionsArgs = {
  role: UserRole;
};

export type RawData = {
  __typename?: 'RawData';
  de?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  stringValue?: Maybe<Scalars['String']>;
  unit: Scalars['String'];
  value?: Maybe<Scalars['Float']>;
};

export type RefreshTokenInput = {
  refreshToken: Scalars['String'];
};

export type RefreshTokenOutput = {
  __typename?: 'RefreshTokenOutput';
  accessToken: Scalars['String'];
  refreshed: Scalars['Boolean'];
};

export type ReleasePlayerScoreInput = {
  playerSessionId: Scalars['Int'];
  sessionNumber: Scalars['Int'];
};

export type ReleasePlayerScoreOutput = {
  __typename?: 'ReleasePlayerScoreOutput';
  playerSessionId: Scalars['Int'];
  sessionNumber: Scalars['Int'];
};

export type ResendExpiredLinkInput = {
  sub: Scalars['String'];
  type: Scalars['String'];
  uuid: Scalars['String'];
};

export type ResendExpiredLinkOutput = {
  __typename?: 'ResendExpiredLinkOutput';
  sent: Scalars['Boolean'];
  sub: Scalars['String'];
  type: Scalars['String'];
  uuid: Scalars['String'];
};

export type ResendLegalGuardianEmailInput = {
  language?: InputMaybe<Scalars['String']>;
  newLegalGuardianEmail?: InputMaybe<Scalars['String']>;
};

export type ResendLegalGuardianEmailOutput = {
  __typename?: 'ResendLegalGuardianEmailOutput';
  emailSent: Scalars['Boolean'];
  legalGuardianEmail: Scalars['String'];
};

export type ResendUserEmailInput = {
  newEmail?: InputMaybe<Scalars['String']>;
};

export type ResendUserEmailOutput = {
  __typename?: 'ResendUserEmailOutput';
  email: Scalars['String'];
  emailSent: Scalars['Boolean'];
};

export type ResetPasswordInput = {
  confirmationPassword: Scalars['String'];
  email: Scalars['String'];
  newPassword: Scalars['String'];
  tempToken: Scalars['String'];
  username: Scalars['String'];
};

export type ResetPasswordOutput = {
  __typename?: 'ResetPasswordOutput';
  passwordChanged: Scalars['String'];
  username: Scalars['String'];
};

export type ResetUserPasswordInput = {
  password: Scalars['String'];
  sub: Scalars['String'];
  type: Scalars['String'];
  uuid: Scalars['String'];
};

export type ResetUserPasswordOutput = {
  __typename?: 'ResetUserPasswordOutput';
  reset: Scalars['Boolean'];
  user: User;
};

export type Score = {
  __typename?: 'Score';
  ageGroup: Scalars['Int'];
  ageGroupValue: Scalars['String'];
  badgeLevel: Scalars['Int'];
  club?: Maybe<Club>;
  date: Scalars['Date'];
  payment?: Maybe<PaymentDetails>;
  playerSessionId: Scalars['Int'];
  released: Scalars['Boolean'];
  score: Scalars['Float'];
  sessionNumber: Scalars['Int'];
  subScores: Array<SubScores>;
  trainers?: Maybe<Array<User>>;
  user?: Maybe<User>;
};

export type ScoutingEvent = {
  __typename?: 'ScoutingEvent';
  club: Club;
  end: Scalars['Date'];
  eventNumber: Scalars['Float'];
  externalSources: Array<Scalars['String']>;
  fixedGoalKeepers: Scalars['Boolean'];
  name: Scalars['String'];
  players: Array<User>;
  sessions: Array<PartialOperatorSession>;
  shotTest: Scalars['Boolean'];
  sprintTest: Scalars['Boolean'];
  start: Scalars['Date'];
  trainers: Array<User>;
};

export type SeparatedDate = {
  __typename?: 'SeparatedDate';
  day: Scalars['String'];
  month: Scalars['String'];
  year: Scalars['String'];
};

export type SeparatedDateInput = {
  day: Scalars['String'];
  month: Scalars['String'];
  year: Scalars['String'];
};

export type Session = {
  __typename?: 'Session';
  ageGroup: Scalars['Int'];
  ageGroupValue: Scalars['String'];
  averages: Array<SubScores>;
  badgeLevel: Scalars['Int'];
  club?: Maybe<Club>;
  date: Scalars['Date'];
  playerCount: Scalars['Int'];
  playerReleased: Scalars['Int'];
  score: Scalars['Float'];
  sessionNumber: Scalars['Int'];
  trainers?: Maybe<Array<User>>;
};

export type SessionOrScore = Score | Session;

export type SignInInput = {
  password: Scalars['String'];
  username: Scalars['String'];
};

export type SignInOutput = {
  __typename?: 'SignInOutput';
  accessToken: Scalars['String'];
  refreshToken: Scalars['String'];
  user: User;
};

export type SignUpInput = {
  birthdate: SeparatedDateInput;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  legalGuardian?: InputMaybe<LegalGuardianSignUpInput>;
  legalGuardianEmail?: InputMaybe<Scalars['String']>;
  newsletterSubscription?: InputMaybe<Scalars['Boolean']>;
  password: Scalars['String'];
  role: UserRole;
  username?: InputMaybe<Scalars['String']>;
};

export type SignUpOutput = {
  __typename?: 'SignUpOutput';
  accessToken: Scalars['String'];
  refreshToken: Scalars['String'];
  registered: Scalars['Boolean'];
  user: User;
};

export type SubScorePlayers = {
  __typename?: 'SubScorePlayers';
  avatarUrl?: Maybe<Scalars['String']>;
  playerSessionId: Scalars['Int'];
  sub?: Maybe<Scalars['String']>;
  value: Scalars['Float'];
};

export type SubScoreTrainingVideos = {
  __typename?: 'SubScoreTrainingVideos';
  playerSessionId: Scalars['Int'];
  sessionNumber: Scalars['Int'];
  trainingsVideos: Array<TrainingsVideo>;
  type: Scalars['String'];
  userId: Scalars['String'];
};

export type SubScores = {
  __typename?: 'SubScores';
  bestPlayers?: Maybe<Array<SubScorePlayers>>;
  counts?: Maybe<Array<Scalars['Int']>>;
  difference?: Maybe<Scalars['Int']>;
  rawData?: Maybe<Array<RawData>>;
  trainingsVideos?: Maybe<Array<TrainingsVideo>>;
  type: Scalars['String'];
  value?: Maybe<Scalars['Int']>;
  worstPlayers?: Maybe<Array<SubScorePlayers>>;
};

export type SystemNotification = {
  __typename?: 'SystemNotification';
  parameters: Array<SystemNotificationParameter>;
  type: Scalars['String'];
};

export type SystemNotificationParameter = {
  __typename?: 'SystemNotificationParameter';
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type Texts = {
  __typename?: 'Texts';
  subtext: Scalars['String'];
  title: Scalars['String'];
};

export type TrainingsVideo = {
  __typename?: 'TrainingsVideo';
  previewUrl?: Maybe<Scalars['String']>;
  texts?: Maybe<Texts>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type UpdateOperatorSessionInput = {
  ageGroup?: InputMaybe<Scalars['String']>;
  clubId?: InputMaybe<Scalars['Int']>;
  fixedGoalkeepers?: InputMaybe<Scalars['Boolean']>;
  ground?: InputMaybe<GroundInput>;
  sessionNumber: Scalars['Int'];
  shotTest?: InputMaybe<Scalars['Boolean']>;
  sprintTest?: InputMaybe<Scalars['Boolean']>;
  trainerCodes?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateOperatorSessionOutput = {
  __typename?: 'UpdateOperatorSessionOutput';
  sessionNumber: Scalars['Int'];
  updated: Scalars['Boolean'];
};

export type UpdateScoutingEventInput = {
  clubId: Scalars['Float'];
  end?: InputMaybe<Scalars['Date']>;
  eventNumber: Scalars['Float'];
  externalSources?: InputMaybe<Array<Scalars['String']>>;
  fixedGoalKeepers?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  playersIds: Array<Scalars['String']>;
  shotTest?: InputMaybe<Scalars['Boolean']>;
  sprintTest?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['Date']>;
  trainerIds: Array<Scalars['String']>;
};

export type UpdateUserAvatarOutput = {
  __typename?: 'UpdateUserAvatarOutput';
  user: User;
};

export type UpdateUserBackgroundOutput = {
  __typename?: 'UpdateUserBackgroundOutput';
  user: User;
};

export type UpdateUserByIdInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  newsletterSubscription?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
};

export type UpdateUserInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  newsletterSubscription?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
};

export type UpdateUserOutput = {
  __typename?: 'UpdateUserOutput';
  user: User;
};

export type UpdateUserPasswordInput = {
  currentPassword: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation?: InputMaybe<Scalars['String']>;
};

export type UpdateUserPasswordOutput = {
  __typename?: 'UpdateUserPasswordOutput';
  user: User;
};

export type UploadSessionVideoOutput = {
  __typename?: 'UploadSessionVideoOutput';
  uploaded: Scalars['Boolean'];
};

export type User = {
  __typename?: 'User';
  address?: Maybe<Address>;
  avatarTimestamp?: Maybe<Scalars['Float']>;
  avatarUrl?: Maybe<Scalars['String']>;
  backgroundTimestamp?: Maybe<Scalars['Float']>;
  backgroundUrl?: Maybe<Scalars['String']>;
  birthdate?: Maybe<SeparatedDate>;
  email?: Maybe<Scalars['String']>;
  emailVerified?: Maybe<Scalars['Boolean']>;
  externalSource?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  legalGuardian?: Maybe<LegalGuardian>;
  name?: Maybe<Scalars['String']>;
  newsletterSubscription: Scalars['Boolean'];
  roles?: Maybe<Array<UserRole>>;
  sub: Scalars['String'];
  username?: Maybe<Scalars['String']>;
};

export type UserOrder = {
  createdTimestamp?: InputMaybe<Order>;
  username?: InputMaybe<Order>;
};

export enum UserRole {
  Admin = 'ADMIN',
  Clubcreator = 'CLUBCREATOR',
  ExternalSource = 'EXTERNAL_SOURCE',
  Operator = 'OPERATOR',
  Player = 'PLAYER',
  ScoutingEventOperator = 'SCOUTING_EVENT_OPERATOR',
  Trainer = 'TRAINER',
  OfflineAccess = 'offline_access',
  PortalUser = 'portal_user',
  UmaAuthorization = 'uma_authorization'
}

export type ValidateCodeOutput = {
  __typename?: 'ValidateCodeOutput';
  code: Scalars['String'];
  valid: Scalars['Boolean'];
};

export type ValidateEmailInput = {
  email: Scalars['String'];
};

export type ValidateEmailOutput = {
  __typename?: 'ValidateEmailOutput';
  email: Scalars['String'];
  valid: Scalars['Boolean'];
};

export type VerifyLegalGuardianInput = {
  legalGuardian: LegalGuardianInput;
  sub: Scalars['String'];
  type: Scalars['String'];
  uuid: Scalars['String'];
};

export type VerifyLegalGuardianOutput = {
  __typename?: 'VerifyLegalGuardianOutput';
  user: User;
  verified: Scalars['Boolean'];
};

export type VerifyUserEmailInput = {
  sub: Scalars['String'];
  type: Scalars['String'];
  uuid: Scalars['String'];
};

export type VerifyUserEmailOutput = {
  __typename?: 'VerifyUserEmailOutput';
  user: User;
  verified: Scalars['Boolean'];
};

export type Video = {
  __typename?: 'Video';
  cookies: Array<Scalars['String']>;
  id: Scalars['String'];
  url: Scalars['String'];
};

export type VideoTumb = {
  __typename?: 'VideoTumb';
  id: Scalars['String'];
  match: Scalars['String'];
  thumb: Scalars['String'];
};

export type WatchComparison = {
  __typename?: 'WatchComparison';
  compareFrom: WatchComparisonResult;
  compareTo: WatchComparisonResult;
  id: Scalars['String'];
  role: UserRole;
  sessionNumber?: Maybe<Scalars['Int']>;
  skill: Scalars['String'];
  sub?: Maybe<Scalars['String']>;
  subFrom?: Maybe<Scalars['String']>;
  type: FoundComparisonType;
};

export type WatchComparisonDeletedOutput = {
  __typename?: 'WatchComparisonDeletedOutput';
  deleted: Scalars['Boolean'];
};

export type WatchComparisonInput = {
  role: UserRole;
  sessionNumber?: InputMaybe<Scalars['Int']>;
  skill: Scalars['String'];
  sub?: InputMaybe<Scalars['String']>;
  subFrom?: InputMaybe<Scalars['String']>;
  type: FoundComparisonType;
};

export type WatchComparisonResult = {
  __typename?: 'WatchComparisonResult';
  avatar?: Maybe<Scalars['String']>;
  date: Scalars['Date'];
  name?: Maybe<Scalars['String']>;
  sessionNumber: Scalars['Int'];
  value: Scalars['Int'];
};

export type WatchScore = {
  __typename?: 'WatchScore';
  avatar?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
  name?: Maybe<Scalars['String']>;
  value: Scalars['Int'];
};

export type WatchSession = {
  __typename?: 'WatchSession';
  id: Scalars['String'];
  playerSessionId?: Maybe<Scalars['Int']>;
  role: UserRole;
  scoreA: WatchScore;
  scoreB: WatchScore;
  sessionNumber?: Maybe<Scalars['Int']>;
  skill: Scalars['String'];
  type: ComparisonType;
};

export type WatchSessionDeletedOutput = {
  __typename?: 'WatchSessionDeletedOutput';
  deleted: Scalars['Boolean'];
};

export type WatchSessionInput = {
  playerSessionId?: InputMaybe<Scalars['Int']>;
  role: UserRole;
  sessionNumber?: InputMaybe<Scalars['Int']>;
  skill: Scalars['String'];
  type: ComparisonType;
};

export type OperatorSessionFragmentFragment = { __typename?: 'OperatorSession', sessionNumber: number, ageGroup: string, fixedGoalkeepers: boolean, sprintTest: boolean, shotTest: boolean, playersCount: number, trainersCount: number, matchesCount: number, processed: boolean, scored: boolean, date: any, allVideosUploaded: boolean, videosUploaded: Array<string>, club: { __typename?: 'Club', id?: number | null, name?: string | null }, ground?: { __typename?: 'Ground', width?: number | null, height?: number | null, goalWidth?: number | null, goalHeight?: number | null } | null };

export type PartialOperatorSessionFragmentFragment = { __typename?: 'PartialOperatorSession', sessionNumber?: number | null, ageGroup?: string | null, fixedGoalkeepers?: boolean | null, sprintTest?: boolean | null, shotTest?: boolean | null, playersCount?: number | null, trainersCount?: number | null, matchesCount?: number | null, processed?: boolean | null, scored?: boolean | null, date?: any | null, allVideosUploaded?: boolean | null, videosUploaded?: Array<string> | null, club?: { __typename?: 'Club', id?: number | null, name?: string | null } | null, ground?: { __typename?: 'Ground', width?: number | null, height?: number | null, goalWidth?: number | null, goalHeight?: number | null } | null };

export type PlayerScoreFragmentFragment = { __typename?: 'Score', playerSessionId: number, sessionNumber: number, score: number, badgeLevel: number, ageGroup: number, ageGroupValue: string, date: any, released: boolean, trainers?: Array<{ __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null }> | null, payment?: { __typename?: 'PaymentDetails', id: number, amount?: number | null, currency?: string | null, paidAt?: any | null } | null, user?: { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null } | null, subScores: Array<{ __typename?: 'SubScores', type: string, value?: number | null, rawData?: Array<{ __typename?: 'RawData', name: string, unit: string, value?: number | null, stringValue?: string | null }> | null }>, club?: { __typename?: 'Club', id?: number | null, logoUrl?: string | null, city?: string | null, country?: string | null, name?: string | null, street?: string | null } | null };

export type TrainerSessionFragmentFragment = { __typename?: 'Session', sessionNumber: number, ageGroup: number, ageGroupValue: string, date: any, score: number, badgeLevel: number, playerCount: number, playerReleased: number, trainers?: Array<{ __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null }> | null, club?: { __typename?: 'Club', id?: number | null, logoUrl?: string | null, city?: string | null, country?: string | null, name?: string | null, street?: string | null } | null, averages: Array<{ __typename?: 'SubScores', type: string, value?: number | null, rawData?: Array<{ __typename?: 'RawData', name: string, unit: string, value?: number | null, stringValue?: string | null }> | null, bestPlayers?: Array<{ __typename?: 'SubScorePlayers', playerSessionId: number, avatarUrl?: string | null, value: number, sub?: string | null }> | null, worstPlayers?: Array<{ __typename?: 'SubScorePlayers', playerSessionId: number, avatarUrl?: string | null, value: number, sub?: string | null }> | null }> };

export type UserFragmentFragment = { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null };

export type AddCodeMutationVariables = Exact<{
  input: AddCodeInput;
}>;


export type AddCodeMutation = { __typename?: 'Mutation', addCode: { __typename: 'Score', date: any, playerSessionId: number, sessionNumber: number, user?: { __typename?: 'User', email?: string | null, firstName?: string | null, lastName?: string | null } | null, payment?: { __typename?: 'PaymentDetails', paidAt?: any | null, amount?: number | null, currency?: string | null, id: number } | null } | { __typename: 'Session', sessionNumber: number } };

export type CancelReleasedPlayerScoreMutationVariables = Exact<{
  input: CancelReleasedPlayerScoreInput;
}>;


export type CancelReleasedPlayerScoreMutation = { __typename?: 'Mutation', cancelReleasedPlayerScore: { __typename?: 'CancelReleasedPlayerScoreOutput', playerSessionId: number, sessionNumber: number } };

export type ConfirmLegalGuardianMutationVariables = Exact<{
  input: ConfirmLegalGuardianInput;
}>;


export type ConfirmLegalGuardianMutation = { __typename?: 'Mutation', confirmLegalGuardian: { __typename?: 'ConfirmLegalGuardianOutput', confirmed: boolean, user: { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null } } };

export type CreateClubMutationVariables = Exact<{
  input: CreateClubInput;
}>;


export type CreateClubMutation = { __typename?: 'Mutation', createClub: { __typename?: 'Club', id?: number | null, city?: string | null, country?: string | null, logoUrl?: string | null, name?: string | null, street?: string | null } };

export type CreateEventMutationVariables = Exact<{
  input: CreateScoutingEventInput;
}>;


export type CreateEventMutation = { __typename?: 'Mutation', createEvent: { __typename?: 'ScoutingEvent', name: string, start: any, end: any, fixedGoalKeepers: boolean, sprintTest: boolean, shotTest: boolean, club: { __typename?: 'Club', id?: number | null, name?: string | null } } };

export type CreateEventSessionMutationVariables = Exact<{
  eventNumber: Scalars['Int'];
  args: CreateOperatorSessionInput;
}>;


export type CreateEventSessionMutation = { __typename?: 'Mutation', createEventSession: { __typename?: 'OperatorSession', sessionNumber: number, ageGroup: string, fixedGoalkeepers: boolean, playersCount: number, trainersCount: number, matchesCount: number } };

export type CreateOperatorSessionMutationVariables = Exact<{
  input: CreateOperatorSessionInput;
}>;


export type CreateOperatorSessionMutation = { __typename?: 'Mutation', createOperatorSession: { __typename?: 'CreateOperatorSessionOutput', sessionNumber: number, created: boolean } };

export type CreateStripeIntentMutationVariables = Exact<{
  input: CreateStripeIntentInput;
}>;


export type CreateStripeIntentMutation = { __typename?: 'Mutation', createStripeIntent: { __typename?: 'CreateStripeIntentOutput', stripeId: string, pubKey: string, clientSecret: string, fresh: boolean } };

export type CreateWatchComparisonMutationVariables = Exact<{
  input: WatchComparisonInput;
}>;


export type CreateWatchComparisonMutation = { __typename?: 'Mutation', createWatchComparison: { __typename?: 'WatchComparison', id: string, role: UserRole, skill: string, type: FoundComparisonType, sessionNumber?: number | null, subFrom?: string | null, sub?: string | null, compareFrom: { __typename?: 'WatchComparisonResult', name?: string | null, sessionNumber: number, avatar?: string | null, date: any, value: number }, compareTo: { __typename?: 'WatchComparisonResult', name?: string | null, sessionNumber: number, avatar?: string | null, date: any, value: number } } };

export type DeleteAccountMutationVariables = Exact<{
  input: DeleteAccountInput;
}>;


export type DeleteAccountMutation = { __typename?: 'Mutation', deleteAccount: { __typename?: 'DeleteAccountOutput', sub: string, deleted: boolean } };

export type DeleteEventMutationVariables = Exact<{
  eventNumber: Scalars['Int'];
}>;


export type DeleteEventMutation = { __typename?: 'Mutation', deleteEvent: boolean };

export type DeleteEventSessionMutationVariables = Exact<{
  eventNumber: Scalars['Int'];
  sessionNumber: Scalars['Int'];
}>;


export type DeleteEventSessionMutation = { __typename?: 'Mutation', deleteEventSession: boolean };

export type DeleteOperatorSessionMutationVariables = Exact<{
  sessionNumber: Scalars['Int'];
}>;


export type DeleteOperatorSessionMutation = { __typename?: 'Mutation', deleteOperatorSession: { __typename?: 'DeleteOperatorSessionOutput', sessionNumber: number, deleted: boolean } };

export type DeleteWatchComparisonMutationVariables = Exact<{
  input: WatchComparisonInput;
}>;


export type DeleteWatchComparisonMutation = { __typename?: 'Mutation', deleteWatchComparison: { __typename?: 'WatchComparisonDeletedOutput', deleted: boolean } };

export type ForgotUserPasswordMutationVariables = Exact<{
  input: ForgotUserPasswordInput;
}>;


export type ForgotUserPasswordMutation = { __typename?: 'Mutation', forgotUserPassword: { __typename?: 'ForgotUserPasswordOutput', email: string, emailSent: boolean } };

export type LogoutMutationVariables = Exact<{
  input: LogoutInput;
}>;


export type LogoutMutation = { __typename?: 'Mutation', logout: { __typename?: 'LogoutOutput', sub: string, logout: boolean } };

export type PayPlayerSessionWithCardMutationVariables = Exact<{
  input: PayPlayerSessionWithCardInput;
}>;


export type PayPlayerSessionWithCardMutation = { __typename?: 'Mutation', payPlayerSessionWithCard: { __typename?: 'PayPlayerSessionWithCardOutput', playerSessionId: number, sessionNumber: number, paidAt: any } };

export type PayPlayerSessionWithPaypalMutationVariables = Exact<{
  input: PayPlayerSessionWithPaypalInput;
}>;


export type PayPlayerSessionWithPaypalMutation = { __typename?: 'Mutation', payPlayerSessionWithPaypal: { __typename?: 'PayPlayerSessionWithPaypalOutput', playerSessionId: number, sessionNumber: number, paidAt: any } };

export type ProcessOperatorSessionMutationVariables = Exact<{
  input: ProcessOperatorSessionInput;
}>;


export type ProcessOperatorSessionMutation = { __typename?: 'Mutation', processOperatorSession: { __typename?: 'ProcessOperatorSessionOutput', sessionNumber: number, processed: boolean } };

export type RefreshTokenMutationVariables = Exact<{
  input: RefreshTokenInput;
}>;


export type RefreshTokenMutation = { __typename?: 'Mutation', refreshToken: { __typename?: 'RefreshTokenOutput', accessToken: string, refreshed: boolean } };

export type ReleasePlayerScoreMutationVariables = Exact<{
  input: ReleasePlayerScoreInput;
}>;


export type ReleasePlayerScoreMutation = { __typename?: 'Mutation', releasePlayerScore: { __typename?: 'ReleasePlayerScoreOutput', playerSessionId: number, sessionNumber: number } };

export type ResendExpiredLinkMutationVariables = Exact<{
  input: ResendExpiredLinkInput;
}>;


export type ResendExpiredLinkMutation = { __typename?: 'Mutation', resendExpiredLink: { __typename?: 'ResendExpiredLinkOutput', type: string, uuid: string, sub: string, sent: boolean } };

export type ResendLegalGuardianEmailMutationVariables = Exact<{
  input: ResendLegalGuardianEmailInput;
}>;


export type ResendLegalGuardianEmailMutation = { __typename?: 'Mutation', resendLegalGuardianEmail: { __typename?: 'ResendLegalGuardianEmailOutput', legalGuardianEmail: string, emailSent: boolean } };

export type ResendUserEmailMutationVariables = Exact<{
  input: ResendUserEmailInput;
}>;


export type ResendUserEmailMutation = { __typename?: 'Mutation', resendUserEmail: { __typename?: 'ResendUserEmailOutput', email: string, emailSent: boolean } };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: { __typename?: 'ResetPasswordOutput', username: string, passwordChanged: string } };

export type ResetUserPasswordMutationVariables = Exact<{
  input: ResetUserPasswordInput;
}>;


export type ResetUserPasswordMutation = { __typename?: 'Mutation', resetUserPassword: { __typename?: 'ResetUserPasswordOutput', reset: boolean, user: { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null } } };

export type SignInMutationVariables = Exact<{
  input: SignInInput;
}>;


export type SignInMutation = { __typename?: 'Mutation', signIn: { __typename?: 'SignInOutput', accessToken: string, refreshToken: string, user: { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null } } };

export type SignUpMutationVariables = Exact<{
  input: SignUpInput;
}>;


export type SignUpMutation = { __typename?: 'Mutation', signUp: { __typename?: 'SignUpOutput', registered: boolean, accessToken: string, refreshToken: string, user: { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null } } };

export type UpdateEventMutationVariables = Exact<{
  input: UpdateScoutingEventInput;
}>;


export type UpdateEventMutation = { __typename?: 'Mutation', updateEvent: { __typename?: 'ScoutingEvent', eventNumber: number, name: string, start: any, end: any, fixedGoalKeepers: boolean, shotTest: boolean, sprintTest: boolean, club: { __typename?: 'Club', id?: number | null, name?: string | null } } };

export type UpdateEventSessionMutationVariables = Exact<{
  eventNumber: Scalars['Int'];
  session: UpdateOperatorSessionInput;
}>;


export type UpdateEventSessionMutation = { __typename?: 'Mutation', UpdateEventSession: { __typename?: 'OperatorSession', sessionNumber: number, ageGroup: string, fixedGoalkeepers: boolean, playersCount: number, trainersCount: number, matchesCount: number } };

export type UpdateOperatorSessionMutationVariables = Exact<{
  input: UpdateOperatorSessionInput;
}>;


export type UpdateOperatorSessionMutation = { __typename?: 'Mutation', updateOperatorSession: { __typename?: 'UpdateOperatorSessionOutput', sessionNumber: number, updated: boolean } };

export type UpdateUserAvatarMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UpdateUserAvatarMutation = { __typename?: 'Mutation', updateUserAvatar: { __typename?: 'UpdateUserAvatarOutput', user: { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null } } };

export type UpdateUserBackgroundMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UpdateUserBackgroundMutation = { __typename?: 'Mutation', updateUserBackground: { __typename?: 'UpdateUserBackgroundOutput', user: { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null } } };

export type UpdateUserPasswordMutationVariables = Exact<{
  input: UpdateUserPasswordInput;
}>;


export type UpdateUserPasswordMutation = { __typename?: 'Mutation', updateUserPassword: { __typename?: 'UpdateUserPasswordOutput', user: { __typename?: 'User', email?: string | null } } };

export type VerifyLegalGuardianMutationVariables = Exact<{
  input: VerifyLegalGuardianInput;
}>;


export type VerifyLegalGuardianMutation = { __typename?: 'Mutation', verifyLegalGuardian: { __typename?: 'VerifyLegalGuardianOutput', verified: boolean, user: { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null } } };

export type VerifyUserEmailMutationVariables = Exact<{
  input: VerifyUserEmailInput;
}>;


export type VerifyUserEmailMutation = { __typename?: 'Mutation', verifyUserEmail: { __typename?: 'VerifyUserEmailOutput', verified: boolean, user: { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null } } };

export type CheckEmailExistQueryVariables = Exact<{
  input: CheckEmailExistInput;
}>;


export type CheckEmailExistQuery = { __typename?: 'Query', checkEmailExist: { __typename?: 'CheckEmailExistOutput', email: string, exist: boolean } };

export type CheckEmailTokenQueryVariables = Exact<{
  input: CheckEmailTokenInput;
}>;


export type CheckEmailTokenQuery = { __typename?: 'Query', checkEmailToken: { __typename?: 'CheckEmailTokenOutput', type: string, uuid: string, sub: string, tokenValid: boolean, user: { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null } } };

export type CheckUserNameExistQueryVariables = Exact<{
  input: CheckUsernameExistInput;
}>;


export type CheckUserNameExistQuery = { __typename?: 'Query', checkUserNameExist: { __typename?: 'CheckUsernameExistOutput', username: string, exist: boolean } };

export type ClubsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type ClubsQuery = { __typename?: 'Query', clubs: Array<{ __typename?: 'Club', id?: number | null, logoUrl?: string | null, city?: string | null, country?: string | null, name?: string | null, street?: string | null }> };

export type CompareQueryVariables = Exact<{
  input: CompareInput;
}>;


export type CompareQuery = { __typename?: 'Query', compare?: { __typename?: 'FoundComparison', role: UserRole, type: FoundComparisonType, sessionNumber?: number | null, subFrom?: string | null, sub?: string | null, difference?: Array<{ __typename?: 'SubScores', type: string, value?: number | null }> | null, compareFrom?: { __typename?: 'FoundComparisonScore', name?: string | null, sessionNumber: number, avatar?: string | null, date?: any | null, subScores?: Array<{ __typename?: 'SubScores', type: string, value?: number | null, rawData?: Array<{ __typename?: 'RawData', name: string, unit: string, value?: number | null, stringValue?: string | null }> | null }> | null } | null, compareTo?: { __typename?: 'FoundComparisonScore', name?: string | null, sessionNumber: number, avatar?: string | null, date?: any | null, subScores?: Array<{ __typename?: 'SubScores', type: string, value?: number | null, rawData?: Array<{ __typename?: 'RawData', name: string, unit: string, value?: number | null, stringValue?: string | null }> | null }> | null } | null } | null };

export type FindComparisonOptionsQueryVariables = Exact<{
  input: FindComparisonOptionsInput;
}>;


export type FindComparisonOptionsQuery = { __typename?: 'Query', findComparisonOptions?: { __typename?: 'ComparisonOptions', compareFrom?: { __typename?: 'WatchComparisonResult', name?: string | null, avatar?: string | null, date: any, sessionNumber: number, value: number } | null, team?: { __typename?: 'Club', id?: number | null, name?: string | null, logoUrl?: string | null, score?: number | null } | null, players: Array<{ __typename?: 'Player', sessionNumber: number, userId?: string | null, playerSessionId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, released: boolean, score?: number | null }>, previous?: Array<{ __typename?: 'PreviousSession', avatar?: string | null, date: any, sessionNumber: number, value?: number | null, released: boolean }> | null } | null };

export type FindEventPlayerQueryVariables = Exact<{
  eventNumber: Scalars['Int'];
  search: Scalars['String'];
}>;


export type FindEventPlayerQuery = { __typename?: 'Query', findEventPlayer: Array<{ __typename?: 'EventPlayer', inSession: boolean, player: { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null } }> };

export type FindEventTrainerQueryVariables = Exact<{
  eventNumber: Scalars['Int'];
  search: Scalars['String'];
}>;


export type FindEventTrainerQuery = { __typename?: 'Query', findEventTrainer: Array<{ __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null }> };

export type FindOperatorSessionByIdQueryVariables = Exact<{
  sessionNumber: Scalars['Int'];
}>;


export type FindOperatorSessionByIdQuery = { __typename?: 'Query', findOperatorSessionById?: { __typename?: 'OperatorSession', sessionNumber: number, ageGroup: string, fixedGoalkeepers: boolean, sprintTest: boolean, shotTest: boolean, playersCount: number, trainersCount: number, matchesCount: number, processed: boolean, scored: boolean, date: any, club: { __typename?: 'Club', id?: number | null, name?: string | null }, ground?: { __typename?: 'Ground', width?: number | null, height?: number | null, goalWidth?: number | null, goalHeight?: number | null } | null } | null };

export type PlayerSessionQueryVariables = Exact<{
  sessionNumber: Scalars['Int'];
  playerSessionId: Scalars['Int'];
}>;


export type PlayerSessionQuery = { __typename?: 'Query', findPlayerScore?: { __typename?: 'Score', playerSessionId: number, sessionNumber: number, score: number, badgeLevel: number, ageGroup: number, ageGroupValue: string, date: any, released: boolean, trainers?: Array<{ __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null }> | null, payment?: { __typename?: 'PaymentDetails', id: number, amount?: number | null, currency?: string | null, paidAt?: any | null } | null, user?: { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null } | null, subScores: Array<{ __typename?: 'SubScores', type: string, value?: number | null, rawData?: Array<{ __typename?: 'RawData', name: string, unit: string, value?: number | null, stringValue?: string | null }> | null }>, club?: { __typename?: 'Club', id?: number | null, logoUrl?: string | null, city?: string | null, country?: string | null, name?: string | null, street?: string | null } | null } | null };

export type FindPlayerScoresByUserIdQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type FindPlayerScoresByUserIdQuery = { __typename?: 'Query', findPlayerScoresByUserId: Array<{ __typename?: 'Score', playerSessionId: number, sessionNumber: number, score: number, badgeLevel: number, ageGroup: number, ageGroupValue: string, date: any, released: boolean, trainers?: Array<{ __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null }> | null, payment?: { __typename?: 'PaymentDetails', id: number, amount?: number | null, currency?: string | null, paidAt?: any | null } | null, user?: { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null } | null, subScores: Array<{ __typename?: 'SubScores', type: string, value?: number | null, rawData?: Array<{ __typename?: 'RawData', name: string, unit: string, value?: number | null, stringValue?: string | null }> | null }>, club?: { __typename?: 'Club', id?: number | null, logoUrl?: string | null, city?: string | null, country?: string | null, name?: string | null, street?: string | null } | null }> };

export type FindPlayersQueryVariables = Exact<{
  sessionNumber: Scalars['Int'];
}>;


export type FindPlayersQuery = { __typename?: 'Query', findPlayers?: Array<{ __typename?: 'Player', sessionNumber: number, playerSessionId: number, score?: number | null, released: boolean, userId?: string | null, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null }> | null };

export type FindVideoQueryVariables = Exact<{
  id: Scalars['String'];
  sessionNumber: Scalars['Int'];
  playerSessionId?: InputMaybe<Scalars['Int']>;
}>;


export type FindVideoQuery = { __typename?: 'Query', findVideo?: { __typename?: 'Video', id: string, url: string, cookies: Array<string> } | null };

export type FindVideosQueryVariables = Exact<{
  role: UserRole;
}>;


export type FindVideosQuery = { __typename?: 'Query', findVideos: Array<{ __typename?: 'FindVideosOutput', date: any, sessionNumber: number, playerSessionId?: number | null, videos: Array<{ __typename?: 'VideoTumb', id: string, thumb: string, match: string }> }> };

export type GetEventQueryVariables = Exact<{
  eventNumber: Scalars['Int'];
}>;


export type GetEventQuery = { __typename?: 'Query', getEvent: { __typename?: 'ScoutingEvent', eventNumber: number, name: string, start: any, end: any, fixedGoalKeepers: boolean, shotTest: boolean, sprintTest: boolean, externalSources: Array<string>, club: { __typename?: 'Club', id?: number | null, name?: string | null }, players: Array<{ __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null }>, trainers: Array<{ __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null }>, sessions: Array<{ __typename?: 'PartialOperatorSession', sessionNumber?: number | null, ageGroup?: string | null, fixedGoalkeepers?: boolean | null, sprintTest?: boolean | null, shotTest?: boolean | null, playersCount?: number | null, trainersCount?: number | null, matchesCount?: number | null, processed?: boolean | null, scored?: boolean | null, date?: any | null, allVideosUploaded?: boolean | null, videosUploaded?: Array<string> | null, club?: { __typename?: 'Club', id?: number | null, name?: string | null } | null, ground?: { __typename?: 'Ground', width?: number | null, height?: number | null, goalWidth?: number | null, goalHeight?: number | null } | null }> } };

export type GetEventSessionQueryVariables = Exact<{
  eventNumber: Scalars['Int'];
  sessionNumber: Scalars['Int'];
}>;


export type GetEventSessionQuery = { __typename?: 'Query', getEventSession: { __typename?: 'OperatorSession', sessionNumber: number, ageGroup: string, fixedGoalkeepers: boolean, sprintTest: boolean, shotTest: boolean, playersCount: number, trainersCount: number, matchesCount: number, processed: boolean, scored: boolean, date: any, allVideosUploaded: boolean, videosUploaded: Array<string>, club: { __typename?: 'Club', id?: number | null, name?: string | null }, ground?: { __typename?: 'Ground', width?: number | null, height?: number | null, goalWidth?: number | null, goalHeight?: number | null } | null } };

export type ListEventSessionsQueryVariables = Exact<{
  eventNumber: Scalars['Int'];
}>;


export type ListEventSessionsQuery = { __typename?: 'Query', listEventSessions: Array<{ __typename?: 'OperatorSession', sessionNumber: number, ageGroup: string, fixedGoalkeepers: boolean, sprintTest: boolean, shotTest: boolean, playersCount: number, trainersCount: number, matchesCount: number, processed: boolean, scored: boolean, date: any, allVideosUploaded: boolean, videosUploaded: Array<string>, club: { __typename?: 'Club', id?: number | null, name?: string | null }, ground?: { __typename?: 'Ground', width?: number | null, height?: number | null, goalWidth?: number | null, goalHeight?: number | null } | null }> };

export type ListEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListEventsQuery = { __typename?: 'Query', listEvents: Array<{ __typename?: 'ScoutingEvent', eventNumber: number, name: string, start: any, end: any, fixedGoalKeepers: boolean, shotTest: boolean, sprintTest: boolean, externalSources: Array<string>, club: { __typename?: 'Club', id?: number | null, name?: string | null }, players: Array<{ __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null }>, trainers: Array<{ __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null }>, sessions: Array<{ __typename?: 'PartialOperatorSession', sessionNumber?: number | null }> }> };

export type GetTrainingVideosQueryVariables = Exact<{
  sessionNumber: Scalars['Int'];
  playerSessionId: Scalars['Int'];
}>;


export type GetTrainingVideosQuery = { __typename?: 'Query', getTrainingVideos: Array<{ __typename?: 'SubScoreTrainingVideos', sessionNumber: number, userId: string, playerSessionId: number, type: string, trainingsVideos: Array<{ __typename?: 'TrainingsVideo', uuid?: string | null, thumbnailUrl?: string | null, previewUrl?: string | null, texts?: { __typename?: 'Texts', title: string, subtext: string } | null }> }> };

export type NotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsQuery = { __typename?: 'Query', notifications: { __typename?: 'NotificationsOutput', minAppVersion: string, unreadCount: number, notificationList: Array<{ __typename?: 'SystemNotification', type: string, parameters: Array<{ __typename?: 'SystemNotificationParameter', key: string, value?: string | null }> }> } };

export type OperatorSessionsQueryVariables = Exact<{ [key: string]: never; }>;


export type OperatorSessionsQuery = { __typename?: 'Query', operatorSessions: Array<{ __typename?: 'OperatorSession', sessionNumber: number, ageGroup: string, fixedGoalkeepers: boolean, sprintTest: boolean, shotTest: boolean, playersCount: number, trainersCount: number, matchesCount: number, processed: boolean, scored: boolean, date: any, allVideosUploaded: boolean, videosUploaded: Array<string>, club: { __typename?: 'Club', id?: number | null, name?: string | null }, ground?: { __typename?: 'Ground', width?: number | null, height?: number | null, goalWidth?: number | null, goalHeight?: number | null } | null }> };

export type PlayerSessionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PlayerSessionsQuery = { __typename?: 'Query', playerScores: Array<{ __typename?: 'Score', playerSessionId: number, sessionNumber: number, score: number, badgeLevel: number, ageGroup: number, ageGroupValue: string, date: any, released: boolean, trainers?: Array<{ __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null }> | null, payment?: { __typename?: 'PaymentDetails', id: number, amount?: number | null, currency?: string | null, paidAt?: any | null } | null, user?: { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null } | null, subScores: Array<{ __typename?: 'SubScores', type: string, value?: number | null, rawData?: Array<{ __typename?: 'RawData', name: string, unit: string, value?: number | null, stringValue?: string | null }> | null }>, club?: { __typename?: 'Club', id?: number | null, logoUrl?: string | null, city?: string | null, country?: string | null, name?: string | null, street?: string | null } | null }> };

export type SearchExternalSourcesQueryVariables = Exact<{
  externalSource: Scalars['String'];
  roles: Array<Scalars['String']> | Scalars['String'];
}>;


export type SearchExternalSourcesQuery = { __typename?: 'Query', searchUsers: Array<{ __typename?: 'User', externalSource?: string | null }> };

export type SearchPlayersQueryVariables = Exact<{
  externalSource: Scalars['String'];
}>;


export type SearchPlayersQuery = { __typename?: 'Query', searchPlayers: Array<{ __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null }> };

export type SearchTrainersQueryVariables = Exact<{
  externalSource: Scalars['String'];
}>;


export type SearchTrainersQuery = { __typename?: 'Query', searchTrainers: Array<{ __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null }> };

export type SearchUsersQueryVariables = Exact<{
  externalSource: Scalars['String'];
  roles: Array<Scalars['String']> | Scalars['String'];
}>;


export type SearchUsersQuery = { __typename?: 'Query', searchUsers: Array<{ __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null }> };

export type TrainerSessionsQueryVariables = Exact<{ [key: string]: never; }>;


export type TrainerSessionsQuery = { __typename?: 'Query', sessions: Array<{ __typename?: 'Session', sessionNumber: number, ageGroup: number, ageGroupValue: string, date: any, score: number, badgeLevel: number, playerCount: number, playerReleased: number, trainers?: Array<{ __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null }> | null, club?: { __typename?: 'Club', id?: number | null, logoUrl?: string | null, city?: string | null, country?: string | null, name?: string | null, street?: string | null } | null, averages: Array<{ __typename?: 'SubScores', type: string, value?: number | null, rawData?: Array<{ __typename?: 'RawData', name: string, unit: string, value?: number | null, stringValue?: string | null }> | null, bestPlayers?: Array<{ __typename?: 'SubScorePlayers', playerSessionId: number, avatarUrl?: string | null, value: number, sub?: string | null }> | null, worstPlayers?: Array<{ __typename?: 'SubScorePlayers', playerSessionId: number, avatarUrl?: string | null, value: number, sub?: string | null }> | null }> }> };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { __typename?: 'Query', user: { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null } };

export type ValidateCodeQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type ValidateCodeQuery = { __typename?: 'Query', validateCode: { __typename?: 'ValidateCodeOutput', code: string, valid: boolean } };

export type ValidateEmailQueryVariables = Exact<{
  input: ValidateEmailInput;
}>;


export type ValidateEmailQuery = { __typename?: 'Query', validateEmail: { __typename?: 'ValidateEmailOutput', email: string, valid: boolean } };

export type WatchComparisonsQueryVariables = Exact<{
  role: UserRole;
}>;


export type WatchComparisonsQuery = { __typename?: 'Query', watchComparisons: Array<{ __typename?: 'WatchComparison', id: string, role: UserRole, skill: string, type: FoundComparisonType, sessionNumber?: number | null, subFrom?: string | null, sub?: string | null, compareFrom: { __typename?: 'WatchComparisonResult', name?: string | null, sessionNumber: number, avatar?: string | null, date: any, value: number }, compareTo: { __typename?: 'WatchComparisonResult', name?: string | null, sessionNumber: number, avatar?: string | null, date: any, value: number } }> };



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AddCodeInput: AddCodeInput;
  AddPlayerCodeInput: AddPlayerCodeInput;
  AddTrainerCodeInput: AddTrainerCodeInput;
  Address: ResolverTypeWrapper<Address>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  CancelReleasedPlayerScoreInput: CancelReleasedPlayerScoreInput;
  CancelReleasedPlayerScoreOutput: ResolverTypeWrapper<CancelReleasedPlayerScoreOutput>;
  Card: Card;
  CheckEmailExistInput: CheckEmailExistInput;
  CheckEmailExistOutput: ResolverTypeWrapper<CheckEmailExistOutput>;
  CheckEmailTokenInput: CheckEmailTokenInput;
  CheckEmailTokenOutput: ResolverTypeWrapper<CheckEmailTokenOutput>;
  CheckUsernameExistInput: CheckUsernameExistInput;
  CheckUsernameExistOutput: ResolverTypeWrapper<CheckUsernameExistOutput>;
  Club: ResolverTypeWrapper<Club>;
  CompareInput: CompareInput;
  Comparison: ResolverTypeWrapper<Comparison>;
  ComparisonOptions: ResolverTypeWrapper<ComparisonOptions>;
  ComparisonScore: ResolverTypeWrapper<ComparisonScore>;
  ComparisonSelected: ComparisonSelected;
  ComparisonType: ComparisonType;
  ConfirmLegalGuardianInput: ConfirmLegalGuardianInput;
  ConfirmLegalGuardianOutput: ResolverTypeWrapper<ConfirmLegalGuardianOutput>;
  ConfirmUserEmailInput: ConfirmUserEmailInput;
  ConfirmUserEmailOutput: ResolverTypeWrapper<ConfirmUserEmailOutput>;
  CreateClubInput: CreateClubInput;
  CreateOperatorSessionInput: CreateOperatorSessionInput;
  CreateOperatorSessionOutput: ResolverTypeWrapper<CreateOperatorSessionOutput>;
  CreateScoutingEventInput: CreateScoutingEventInput;
  CreateStripeIntentInput: CreateStripeIntentInput;
  CreateStripeIntentOutput: ResolverTypeWrapper<CreateStripeIntentOutput>;
  Date: ResolverTypeWrapper<Scalars['Date']>;
  DeleteAccountInput: DeleteAccountInput;
  DeleteAccountOutput: ResolverTypeWrapper<DeleteAccountOutput>;
  DeleteOperatorSessionOutput: ResolverTypeWrapper<DeleteOperatorSessionOutput>;
  EventPlayer: ResolverTypeWrapper<EventPlayer>;
  FindComparisonInput: FindComparisonInput;
  FindComparisonOptionsInput: FindComparisonOptionsInput;
  FindVideosOutput: ResolverTypeWrapper<FindVideosOutput>;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  ForgotPasswordInput: ForgotPasswordInput;
  ForgotPasswordOutput: ResolverTypeWrapper<ForgotPasswordOutput>;
  ForgotUserPasswordInput: ForgotUserPasswordInput;
  ForgotUserPasswordOutput: ResolverTypeWrapper<ForgotUserPasswordOutput>;
  FoundComparison: ResolverTypeWrapper<FoundComparison>;
  FoundComparisonScore: ResolverTypeWrapper<FoundComparisonScore>;
  FoundComparisonType: FoundComparisonType;
  GeoLocation: GeoLocation;
  GetEmailVerificationTokenInput: GetEmailVerificationTokenInput;
  GetEmailVerificationTokenOutput: ResolverTypeWrapper<GetEmailVerificationTokenOutput>;
  Ground: ResolverTypeWrapper<Ground>;
  GroundInput: GroundInput;
  ImpersonateInput: ImpersonateInput;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  LegalGuardian: ResolverTypeWrapper<LegalGuardian>;
  LegalGuardianInput: LegalGuardianInput;
  LegalGuardianSignUpInput: LegalGuardianSignUpInput;
  LogoutInput: LogoutInput;
  LogoutOutput: ResolverTypeWrapper<LogoutOutput>;
  Match: Match;
  Mutation: ResolverTypeWrapper<{}>;
  NotificationKey: NotificationKey;
  NotificationType: NotificationType;
  NotificationsOutput: ResolverTypeWrapper<NotificationsOutput>;
  OperatorSession: ResolverTypeWrapper<OperatorSession>;
  Order: Order;
  PaginatedUsersInput: PaginatedUsersInput;
  PaginatedUsersOutput: ResolverTypeWrapper<PaginatedUsersOutput>;
  PartialOperatorSession: ResolverTypeWrapper<PartialOperatorSession>;
  PayPlayerSessionWithCardInput: PayPlayerSessionWithCardInput;
  PayPlayerSessionWithCardOutput: ResolverTypeWrapper<PayPlayerSessionWithCardOutput>;
  PayPlayerSessionWithPaypalInput: PayPlayerSessionWithPaypalInput;
  PayPlayerSessionWithPaypalOutput: ResolverTypeWrapper<PayPlayerSessionWithPaypalOutput>;
  PaymentDetails: ResolverTypeWrapper<PaymentDetails>;
  Player: ResolverTypeWrapper<Player>;
  PlayerGoals: PlayerGoals;
  PreviousSession: ResolverTypeWrapper<PreviousSession>;
  ProcessOperatorSessionInput: ProcessOperatorSessionInput;
  ProcessOperatorSessionOutput: ResolverTypeWrapper<ProcessOperatorSessionOutput>;
  Query: ResolverTypeWrapper<{}>;
  RawData: ResolverTypeWrapper<RawData>;
  RefreshTokenInput: RefreshTokenInput;
  RefreshTokenOutput: ResolverTypeWrapper<RefreshTokenOutput>;
  ReleasePlayerScoreInput: ReleasePlayerScoreInput;
  ReleasePlayerScoreOutput: ResolverTypeWrapper<ReleasePlayerScoreOutput>;
  ResendExpiredLinkInput: ResendExpiredLinkInput;
  ResendExpiredLinkOutput: ResolverTypeWrapper<ResendExpiredLinkOutput>;
  ResendLegalGuardianEmailInput: ResendLegalGuardianEmailInput;
  ResendLegalGuardianEmailOutput: ResolverTypeWrapper<ResendLegalGuardianEmailOutput>;
  ResendUserEmailInput: ResendUserEmailInput;
  ResendUserEmailOutput: ResolverTypeWrapper<ResendUserEmailOutput>;
  ResetPasswordInput: ResetPasswordInput;
  ResetPasswordOutput: ResolverTypeWrapper<ResetPasswordOutput>;
  ResetUserPasswordInput: ResetUserPasswordInput;
  ResetUserPasswordOutput: ResolverTypeWrapper<ResetUserPasswordOutput>;
  Score: ResolverTypeWrapper<Score>;
  ScoutingEvent: ResolverTypeWrapper<ScoutingEvent>;
  SeparatedDate: ResolverTypeWrapper<SeparatedDate>;
  SeparatedDateInput: SeparatedDateInput;
  Session: ResolverTypeWrapper<Session>;
  SessionOrScore: ResolversTypes['Score'] | ResolversTypes['Session'];
  SignInInput: SignInInput;
  SignInOutput: ResolverTypeWrapper<SignInOutput>;
  SignUpInput: SignUpInput;
  SignUpOutput: ResolverTypeWrapper<SignUpOutput>;
  String: ResolverTypeWrapper<Scalars['String']>;
  SubScorePlayers: ResolverTypeWrapper<SubScorePlayers>;
  SubScoreTrainingVideos: ResolverTypeWrapper<SubScoreTrainingVideos>;
  SubScores: ResolverTypeWrapper<SubScores>;
  SystemNotification: ResolverTypeWrapper<SystemNotification>;
  SystemNotificationParameter: ResolverTypeWrapper<SystemNotificationParameter>;
  Texts: ResolverTypeWrapper<Texts>;
  TrainingsVideo: ResolverTypeWrapper<TrainingsVideo>;
  UpdateOperatorSessionInput: UpdateOperatorSessionInput;
  UpdateOperatorSessionOutput: ResolverTypeWrapper<UpdateOperatorSessionOutput>;
  UpdateScoutingEventInput: UpdateScoutingEventInput;
  UpdateUserAvatarOutput: ResolverTypeWrapper<UpdateUserAvatarOutput>;
  UpdateUserBackgroundOutput: ResolverTypeWrapper<UpdateUserBackgroundOutput>;
  UpdateUserByIdInput: UpdateUserByIdInput;
  UpdateUserInput: UpdateUserInput;
  UpdateUserOutput: ResolverTypeWrapper<UpdateUserOutput>;
  UpdateUserPasswordInput: UpdateUserPasswordInput;
  UpdateUserPasswordOutput: ResolverTypeWrapper<UpdateUserPasswordOutput>;
  Upload: ResolverTypeWrapper<Scalars['Upload']>;
  UploadSessionVideoOutput: ResolverTypeWrapper<UploadSessionVideoOutput>;
  User: ResolverTypeWrapper<User>;
  UserOrder: UserOrder;
  UserRole: UserRole;
  ValidateCodeOutput: ResolverTypeWrapper<ValidateCodeOutput>;
  ValidateEmailInput: ValidateEmailInput;
  ValidateEmailOutput: ResolverTypeWrapper<ValidateEmailOutput>;
  VerifyLegalGuardianInput: VerifyLegalGuardianInput;
  VerifyLegalGuardianOutput: ResolverTypeWrapper<VerifyLegalGuardianOutput>;
  VerifyUserEmailInput: VerifyUserEmailInput;
  VerifyUserEmailOutput: ResolverTypeWrapper<VerifyUserEmailOutput>;
  Video: ResolverTypeWrapper<Video>;
  VideoTumb: ResolverTypeWrapper<VideoTumb>;
  WatchComparison: ResolverTypeWrapper<WatchComparison>;
  WatchComparisonDeletedOutput: ResolverTypeWrapper<WatchComparisonDeletedOutput>;
  WatchComparisonInput: WatchComparisonInput;
  WatchComparisonResult: ResolverTypeWrapper<WatchComparisonResult>;
  WatchScore: ResolverTypeWrapper<WatchScore>;
  WatchSession: ResolverTypeWrapper<WatchSession>;
  WatchSessionDeletedOutput: ResolverTypeWrapper<WatchSessionDeletedOutput>;
  WatchSessionInput: WatchSessionInput;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  AddCodeInput: AddCodeInput;
  AddPlayerCodeInput: AddPlayerCodeInput;
  AddTrainerCodeInput: AddTrainerCodeInput;
  Address: Address;
  Boolean: Scalars['Boolean'];
  CancelReleasedPlayerScoreInput: CancelReleasedPlayerScoreInput;
  CancelReleasedPlayerScoreOutput: CancelReleasedPlayerScoreOutput;
  Card: Card;
  CheckEmailExistInput: CheckEmailExistInput;
  CheckEmailExistOutput: CheckEmailExistOutput;
  CheckEmailTokenInput: CheckEmailTokenInput;
  CheckEmailTokenOutput: CheckEmailTokenOutput;
  CheckUsernameExistInput: CheckUsernameExistInput;
  CheckUsernameExistOutput: CheckUsernameExistOutput;
  Club: Club;
  CompareInput: CompareInput;
  Comparison: Comparison;
  ComparisonOptions: ComparisonOptions;
  ComparisonScore: ComparisonScore;
  ConfirmLegalGuardianInput: ConfirmLegalGuardianInput;
  ConfirmLegalGuardianOutput: ConfirmLegalGuardianOutput;
  ConfirmUserEmailInput: ConfirmUserEmailInput;
  ConfirmUserEmailOutput: ConfirmUserEmailOutput;
  CreateClubInput: CreateClubInput;
  CreateOperatorSessionInput: CreateOperatorSessionInput;
  CreateOperatorSessionOutput: CreateOperatorSessionOutput;
  CreateScoutingEventInput: CreateScoutingEventInput;
  CreateStripeIntentInput: CreateStripeIntentInput;
  CreateStripeIntentOutput: CreateStripeIntentOutput;
  Date: Scalars['Date'];
  DeleteAccountInput: DeleteAccountInput;
  DeleteAccountOutput: DeleteAccountOutput;
  DeleteOperatorSessionOutput: DeleteOperatorSessionOutput;
  EventPlayer: EventPlayer;
  FindComparisonInput: FindComparisonInput;
  FindComparisonOptionsInput: FindComparisonOptionsInput;
  FindVideosOutput: FindVideosOutput;
  Float: Scalars['Float'];
  ForgotPasswordInput: ForgotPasswordInput;
  ForgotPasswordOutput: ForgotPasswordOutput;
  ForgotUserPasswordInput: ForgotUserPasswordInput;
  ForgotUserPasswordOutput: ForgotUserPasswordOutput;
  FoundComparison: FoundComparison;
  FoundComparisonScore: FoundComparisonScore;
  GeoLocation: GeoLocation;
  GetEmailVerificationTokenInput: GetEmailVerificationTokenInput;
  GetEmailVerificationTokenOutput: GetEmailVerificationTokenOutput;
  Ground: Ground;
  GroundInput: GroundInput;
  ImpersonateInput: ImpersonateInput;
  Int: Scalars['Int'];
  LegalGuardian: LegalGuardian;
  LegalGuardianInput: LegalGuardianInput;
  LegalGuardianSignUpInput: LegalGuardianSignUpInput;
  LogoutInput: LogoutInput;
  LogoutOutput: LogoutOutput;
  Match: Match;
  Mutation: {};
  NotificationsOutput: NotificationsOutput;
  OperatorSession: OperatorSession;
  PaginatedUsersInput: PaginatedUsersInput;
  PaginatedUsersOutput: PaginatedUsersOutput;
  PartialOperatorSession: PartialOperatorSession;
  PayPlayerSessionWithCardInput: PayPlayerSessionWithCardInput;
  PayPlayerSessionWithCardOutput: PayPlayerSessionWithCardOutput;
  PayPlayerSessionWithPaypalInput: PayPlayerSessionWithPaypalInput;
  PayPlayerSessionWithPaypalOutput: PayPlayerSessionWithPaypalOutput;
  PaymentDetails: PaymentDetails;
  Player: Player;
  PlayerGoals: PlayerGoals;
  PreviousSession: PreviousSession;
  ProcessOperatorSessionInput: ProcessOperatorSessionInput;
  ProcessOperatorSessionOutput: ProcessOperatorSessionOutput;
  Query: {};
  RawData: RawData;
  RefreshTokenInput: RefreshTokenInput;
  RefreshTokenOutput: RefreshTokenOutput;
  ReleasePlayerScoreInput: ReleasePlayerScoreInput;
  ReleasePlayerScoreOutput: ReleasePlayerScoreOutput;
  ResendExpiredLinkInput: ResendExpiredLinkInput;
  ResendExpiredLinkOutput: ResendExpiredLinkOutput;
  ResendLegalGuardianEmailInput: ResendLegalGuardianEmailInput;
  ResendLegalGuardianEmailOutput: ResendLegalGuardianEmailOutput;
  ResendUserEmailInput: ResendUserEmailInput;
  ResendUserEmailOutput: ResendUserEmailOutput;
  ResetPasswordInput: ResetPasswordInput;
  ResetPasswordOutput: ResetPasswordOutput;
  ResetUserPasswordInput: ResetUserPasswordInput;
  ResetUserPasswordOutput: ResetUserPasswordOutput;
  Score: Score;
  ScoutingEvent: ScoutingEvent;
  SeparatedDate: SeparatedDate;
  SeparatedDateInput: SeparatedDateInput;
  Session: Session;
  SessionOrScore: ResolversParentTypes['Score'] | ResolversParentTypes['Session'];
  SignInInput: SignInInput;
  SignInOutput: SignInOutput;
  SignUpInput: SignUpInput;
  SignUpOutput: SignUpOutput;
  String: Scalars['String'];
  SubScorePlayers: SubScorePlayers;
  SubScoreTrainingVideos: SubScoreTrainingVideos;
  SubScores: SubScores;
  SystemNotification: SystemNotification;
  SystemNotificationParameter: SystemNotificationParameter;
  Texts: Texts;
  TrainingsVideo: TrainingsVideo;
  UpdateOperatorSessionInput: UpdateOperatorSessionInput;
  UpdateOperatorSessionOutput: UpdateOperatorSessionOutput;
  UpdateScoutingEventInput: UpdateScoutingEventInput;
  UpdateUserAvatarOutput: UpdateUserAvatarOutput;
  UpdateUserBackgroundOutput: UpdateUserBackgroundOutput;
  UpdateUserByIdInput: UpdateUserByIdInput;
  UpdateUserInput: UpdateUserInput;
  UpdateUserOutput: UpdateUserOutput;
  UpdateUserPasswordInput: UpdateUserPasswordInput;
  UpdateUserPasswordOutput: UpdateUserPasswordOutput;
  Upload: Scalars['Upload'];
  UploadSessionVideoOutput: UploadSessionVideoOutput;
  User: User;
  UserOrder: UserOrder;
  ValidateCodeOutput: ValidateCodeOutput;
  ValidateEmailInput: ValidateEmailInput;
  ValidateEmailOutput: ValidateEmailOutput;
  VerifyLegalGuardianInput: VerifyLegalGuardianInput;
  VerifyLegalGuardianOutput: VerifyLegalGuardianOutput;
  VerifyUserEmailInput: VerifyUserEmailInput;
  VerifyUserEmailOutput: VerifyUserEmailOutput;
  Video: Video;
  VideoTumb: VideoTumb;
  WatchComparison: WatchComparison;
  WatchComparisonDeletedOutput: WatchComparisonDeletedOutput;
  WatchComparisonInput: WatchComparisonInput;
  WatchComparisonResult: WatchComparisonResult;
  WatchScore: WatchScore;
  WatchSession: WatchSession;
  WatchSessionDeletedOutput: WatchSessionDeletedOutput;
  WatchSessionInput: WatchSessionInput;
};

export type AddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['Address'] = ResolversParentTypes['Address']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancelReleasedPlayerScoreOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancelReleasedPlayerScoreOutput'] = ResolversParentTypes['CancelReleasedPlayerScoreOutput']> = {
  playerSessionId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sessionNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckEmailExistOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckEmailExistOutput'] = ResolversParentTypes['CheckEmailExistOutput']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  exist?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckEmailTokenOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckEmailTokenOutput'] = ResolversParentTypes['CheckEmailTokenOutput']> = {
  sub?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tokenValid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckUsernameExistOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckUsernameExistOutput'] = ResolversParentTypes['CheckUsernameExistOutput']> = {
  exist?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClubResolvers<ContextType = any, ParentType extends ResolversParentTypes['Club'] = ResolversParentTypes['Club']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ComparisonResolvers<ContextType = any, ParentType extends ResolversParentTypes['Comparison'] = ResolversParentTypes['Comparison']> = {
  compareA?: Resolver<ResolversTypes['ComparisonScore'], ParentType, ContextType>;
  compareB?: Resolver<ResolversTypes['ComparisonScore'], ParentType, ContextType>;
  difference?: Resolver<Array<ResolversTypes['SubScores']>, ParentType, ContextType>;
  playerSessionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['UserRole'], ParentType, ContextType>;
  sessionNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ComparisonType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ComparisonOptionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ComparisonOptions'] = ResolversParentTypes['ComparisonOptions']> = {
  compareFrom?: Resolver<Maybe<ResolversTypes['WatchComparisonResult']>, ParentType, ContextType>;
  players?: Resolver<Array<ResolversTypes['Player']>, ParentType, ContextType>;
  previous?: Resolver<Maybe<Array<ResolversTypes['PreviousSession']>>, ParentType, ContextType>;
  team?: Resolver<Maybe<ResolversTypes['Club']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ComparisonScoreResolvers<ContextType = any, ParentType extends ResolversParentTypes['ComparisonScore'] = ResolversParentTypes['ComparisonScore']> = {
  avatar?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subScores?: Resolver<Array<ResolversTypes['SubScores']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConfirmLegalGuardianOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConfirmLegalGuardianOutput'] = ResolversParentTypes['ConfirmLegalGuardianOutput']> = {
  confirmed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConfirmUserEmailOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConfirmUserEmailOutput'] = ResolversParentTypes['ConfirmUserEmailOutput']> = {
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateOperatorSessionOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateOperatorSessionOutput'] = ResolversParentTypes['CreateOperatorSessionOutput']> = {
  created?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sessionNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateStripeIntentOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateStripeIntentOutput'] = ResolversParentTypes['CreateStripeIntentOutput']> = {
  clientSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fresh?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  pubKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stripeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date';
}

export type DeleteAccountOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteAccountOutput'] = ResolversParentTypes['DeleteAccountOutput']> = {
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sub?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteOperatorSessionOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteOperatorSessionOutput'] = ResolversParentTypes['DeleteOperatorSessionOutput']> = {
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sessionNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventPlayerResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventPlayer'] = ResolversParentTypes['EventPlayer']> = {
  inSession?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  player?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FindVideosOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['FindVideosOutput'] = ResolversParentTypes['FindVideosOutput']> = {
  date?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  playerSessionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sessionNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  videos?: Resolver<Array<ResolversTypes['VideoTumb']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ForgotPasswordOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['ForgotPasswordOutput'] = ResolversParentTypes['ForgotPasswordOutput']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  emailSent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ForgotUserPasswordOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['ForgotUserPasswordOutput'] = ResolversParentTypes['ForgotUserPasswordOutput']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  emailSent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FoundComparisonResolvers<ContextType = any, ParentType extends ResolversParentTypes['FoundComparison'] = ResolversParentTypes['FoundComparison']> = {
  compareFrom?: Resolver<Maybe<ResolversTypes['FoundComparisonScore']>, ParentType, ContextType>;
  compareTo?: Resolver<Maybe<ResolversTypes['FoundComparisonScore']>, ParentType, ContextType>;
  difference?: Resolver<Maybe<Array<ResolversTypes['SubScores']>>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['UserRole'], ParentType, ContextType>;
  sessionNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sub?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subFrom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['FoundComparisonType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FoundComparisonScoreResolvers<ContextType = any, ParentType extends ResolversParentTypes['FoundComparisonScore'] = ResolversParentTypes['FoundComparisonScore']> = {
  avatar?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sessionNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  subScores?: Resolver<Maybe<Array<ResolversTypes['SubScores']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetEmailVerificationTokenOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetEmailVerificationTokenOutput'] = ResolversParentTypes['GetEmailVerificationTokenOutput']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expiredIn?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  sub?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroundResolvers<ContextType = any, ParentType extends ResolversParentTypes['Ground'] = ResolversParentTypes['Ground']> = {
  goalHeight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  goalWidth?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  height?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LegalGuardianResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegalGuardian'] = ResolversParentTypes['LegalGuardian']> = {
  birthdate?: Resolver<Maybe<ResolversTypes['SeparatedDate']>, ParentType, ContextType>;
  consent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LogoutOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['LogoutOutput'] = ResolversParentTypes['LogoutOutput']> = {
  logout?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sub?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  UpdateEventSession?: Resolver<ResolversTypes['OperatorSession'], ParentType, ContextType, RequireFields<MutationUpdateEventSessionArgs, 'eventNumber' | 'session'>>;
  addCode?: Resolver<ResolversTypes['SessionOrScore'], ParentType, ContextType, RequireFields<MutationAddCodeArgs, 'addCodeInput'>>;
  addPlayerCode?: Resolver<ResolversTypes['Score'], ParentType, ContextType, RequireFields<MutationAddPlayerCodeArgs, 'addPlayerCodeInput'>>;
  addTrainerCode?: Resolver<ResolversTypes['Session'], ParentType, ContextType, RequireFields<MutationAddTrainerCodeArgs, 'addTrainerCodeInput'>>;
  cancelReleasedPlayerScore?: Resolver<ResolversTypes['CancelReleasedPlayerScoreOutput'], ParentType, ContextType, RequireFields<MutationCancelReleasedPlayerScoreArgs, 'cancelReleasedPlayerScoreInput'>>;
  confirmLegalGuardian?: Resolver<ResolversTypes['ConfirmLegalGuardianOutput'], ParentType, ContextType, RequireFields<MutationConfirmLegalGuardianArgs, 'confirmLegalGuardianInput'>>;
  confirmUserEmail?: Resolver<ResolversTypes['ConfirmUserEmailOutput'], ParentType, ContextType, RequireFields<MutationConfirmUserEmailArgs, 'confirmUserEmailInput'>>;
  createClub?: Resolver<ResolversTypes['Club'], ParentType, ContextType, RequireFields<MutationCreateClubArgs, 'createClubInput'>>;
  createEvent?: Resolver<ResolversTypes['ScoutingEvent'], ParentType, ContextType, RequireFields<MutationCreateEventArgs, 'createScoutingEventInput'>>;
  createEventSession?: Resolver<ResolversTypes['OperatorSession'], ParentType, ContextType, RequireFields<MutationCreateEventSessionArgs, 'args' | 'eventNumber'>>;
  createOperatorSession?: Resolver<ResolversTypes['CreateOperatorSessionOutput'], ParentType, ContextType, RequireFields<MutationCreateOperatorSessionArgs, 'createOperatorSessionInput'>>;
  createStripeIntent?: Resolver<ResolversTypes['CreateStripeIntentOutput'], ParentType, ContextType, RequireFields<MutationCreateStripeIntentArgs, 'createStripeIntentInput'>>;
  createWatchComparison?: Resolver<ResolversTypes['WatchComparison'], ParentType, ContextType, RequireFields<MutationCreateWatchComparisonArgs, 'createWatchComparisonInput'>>;
  createWatchSession?: Resolver<ResolversTypes['WatchSession'], ParentType, ContextType, RequireFields<MutationCreateWatchSessionArgs, 'createWatchSessionInput'>>;
  deleteAccount?: Resolver<ResolversTypes['DeleteAccountOutput'], ParentType, ContextType, RequireFields<MutationDeleteAccountArgs, 'deleteAccountInput'>>;
  deleteEvent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteEventArgs, 'eventNumber'>>;
  deleteEventSession?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteEventSessionArgs, 'eventNumber' | 'sessionNumber'>>;
  deleteOperatorSession?: Resolver<ResolversTypes['DeleteOperatorSessionOutput'], ParentType, ContextType, RequireFields<MutationDeleteOperatorSessionArgs, 'sessionNumber'>>;
  deleteUser?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteUserArgs, 'id'>>;
  deleteWatchComparison?: Resolver<ResolversTypes['WatchComparisonDeletedOutput'], ParentType, ContextType, RequireFields<MutationDeleteWatchComparisonArgs, 'deleteWatchComparisonInput'>>;
  deleteWatchSession?: Resolver<ResolversTypes['WatchSessionDeletedOutput'], ParentType, ContextType, RequireFields<MutationDeleteWatchSessionArgs, 'deleteWatchSessionInput'>>;
  forgotPassword?: Resolver<ResolversTypes['ForgotPasswordOutput'], ParentType, ContextType, RequireFields<MutationForgotPasswordArgs, 'forgotPasswordInput'>>;
  forgotUserPassword?: Resolver<ResolversTypes['ForgotUserPasswordOutput'], ParentType, ContextType, RequireFields<MutationForgotUserPasswordArgs, 'forgotUserPasswordInput'>>;
  impersonate?: Resolver<ResolversTypes['SignInOutput'], ParentType, ContextType, RequireFields<MutationImpersonateArgs, 'impersonateInput'>>;
  logout?: Resolver<ResolversTypes['LogoutOutput'], ParentType, ContextType, RequireFields<MutationLogoutArgs, 'logoutInput'>>;
  payPlayerSessionWithCard?: Resolver<ResolversTypes['PayPlayerSessionWithCardOutput'], ParentType, ContextType, RequireFields<MutationPayPlayerSessionWithCardArgs, 'payPlayerSessionWithCardInput'>>;
  payPlayerSessionWithPaypal?: Resolver<ResolversTypes['PayPlayerSessionWithPaypalOutput'], ParentType, ContextType, RequireFields<MutationPayPlayerSessionWithPaypalArgs, 'payPlayerSessionWithPaypalInput'>>;
  processOperatorSession?: Resolver<ResolversTypes['ProcessOperatorSessionOutput'], ParentType, ContextType, RequireFields<MutationProcessOperatorSessionArgs, 'processOperatorSessionInput'>>;
  refreshToken?: Resolver<ResolversTypes['RefreshTokenOutput'], ParentType, ContextType, RequireFields<MutationRefreshTokenArgs, 'refreshTokenInput'>>;
  releasePlayerScore?: Resolver<ResolversTypes['ReleasePlayerScoreOutput'], ParentType, ContextType, RequireFields<MutationReleasePlayerScoreArgs, 'releasePlayerScoreInput'>>;
  resendExpiredLink?: Resolver<ResolversTypes['ResendExpiredLinkOutput'], ParentType, ContextType, RequireFields<MutationResendExpiredLinkArgs, 'resendExpiredLinkInput'>>;
  resendLegalGuardianEmail?: Resolver<ResolversTypes['ResendLegalGuardianEmailOutput'], ParentType, ContextType, RequireFields<MutationResendLegalGuardianEmailArgs, 'resendLegalGuardianEmailInput'>>;
  resendUserEmail?: Resolver<ResolversTypes['ResendUserEmailOutput'], ParentType, ContextType, RequireFields<MutationResendUserEmailArgs, 'resendUserEmailInput'>>;
  resetPassword?: Resolver<ResolversTypes['ResetPasswordOutput'], ParentType, ContextType, RequireFields<MutationResetPasswordArgs, 'resetPasswordInput'>>;
  resetUserPassword?: Resolver<ResolversTypes['ResetUserPasswordOutput'], ParentType, ContextType, RequireFields<MutationResetUserPasswordArgs, 'resetUserPasswordInput'>>;
  signIn?: Resolver<ResolversTypes['SignInOutput'], ParentType, ContextType, RequireFields<MutationSignInArgs, 'signInInput'>>;
  signUp?: Resolver<ResolversTypes['SignUpOutput'], ParentType, ContextType, RequireFields<MutationSignUpArgs, 'signUpInput'>>;
  signin?: Resolver<ResolversTypes['SignInOutput'], ParentType, ContextType, RequireFields<MutationSigninArgs, 'signInInput'>>;
  signup?: Resolver<ResolversTypes['SignUpOutput'], ParentType, ContextType, RequireFields<MutationSignupArgs, 'signUpInput'>>;
  updateEvent?: Resolver<ResolversTypes['ScoutingEvent'], ParentType, ContextType, RequireFields<MutationUpdateEventArgs, 'updateScoutingEventInput'>>;
  updateOperatorSession?: Resolver<ResolversTypes['UpdateOperatorSessionOutput'], ParentType, ContextType, RequireFields<MutationUpdateOperatorSessionArgs, 'updateOperatorSessionInput'>>;
  updateUser?: Resolver<ResolversTypes['UpdateUserOutput'], ParentType, ContextType, RequireFields<MutationUpdateUserArgs, 'updateUserInput'>>;
  updateUserAvatar?: Resolver<ResolversTypes['UpdateUserAvatarOutput'], ParentType, ContextType, RequireFields<MutationUpdateUserAvatarArgs, 'file'>>;
  updateUserBackground?: Resolver<ResolversTypes['UpdateUserBackgroundOutput'], ParentType, ContextType, RequireFields<MutationUpdateUserBackgroundArgs, 'file'>>;
  updateUserById?: Resolver<ResolversTypes['UpdateUserOutput'], ParentType, ContextType, RequireFields<MutationUpdateUserByIdArgs, 'updateUserByIdInput'>>;
  updateUserPassword?: Resolver<ResolversTypes['UpdateUserPasswordOutput'], ParentType, ContextType, RequireFields<MutationUpdateUserPasswordArgs, 'updateUserPasswordInput'>>;
  uploadSessionVideo?: Resolver<ResolversTypes['UploadSessionVideoOutput'], ParentType, ContextType, RequireFields<MutationUploadSessionVideoArgs, 'file' | 'sessionNumber' | 'videoType'>>;
  verifyLegalGuardian?: Resolver<ResolversTypes['VerifyLegalGuardianOutput'], ParentType, ContextType, RequireFields<MutationVerifyLegalGuardianArgs, 'verifyLegalGuardianInput'>>;
  verifyUserEmail?: Resolver<ResolversTypes['VerifyUserEmailOutput'], ParentType, ContextType, RequireFields<MutationVerifyUserEmailArgs, 'verifyUserEmailInput'>>;
};

export type NotificationsOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationsOutput'] = ResolversParentTypes['NotificationsOutput']> = {
  minAppVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  notificationList?: Resolver<Array<ResolversTypes['SystemNotification']>, ParentType, ContextType>;
  unreadCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OperatorSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OperatorSession'] = ResolversParentTypes['OperatorSession']> = {
  ageGroup?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  allVideosUploaded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  club?: Resolver<ResolversTypes['Club'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  fixedGoalkeepers?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  ground?: Resolver<Maybe<ResolversTypes['Ground']>, ParentType, ContextType>;
  matchesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  playersCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  processed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  scored?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sessionNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  shotTest?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sprintTest?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  trainersCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  videosUploaded?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaginatedUsersOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaginatedUsersOutput'] = ResolversParentTypes['PaginatedUsersOutput']> = {
  count?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  result?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
  skip?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  take?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PartialOperatorSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PartialOperatorSession'] = ResolversParentTypes['PartialOperatorSession']> = {
  ageGroup?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  allVideosUploaded?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  club?: Resolver<Maybe<ResolversTypes['Club']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  fixedGoalkeepers?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ground?: Resolver<Maybe<ResolversTypes['Ground']>, ParentType, ContextType>;
  matchesCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  playersCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  processed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  scored?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sessionNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shotTest?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sprintTest?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  trainersCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  videosUploaded?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayPlayerSessionWithCardOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayPlayerSessionWithCardOutput'] = ResolversParentTypes['PayPlayerSessionWithCardOutput']> = {
  paidAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  playerSessionId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sessionNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayPlayerSessionWithPaypalOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayPlayerSessionWithPaypalOutput'] = ResolversParentTypes['PayPlayerSessionWithPaypalOutput']> = {
  paidAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  playerSessionId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sessionNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentDetails'] = ResolversParentTypes['PaymentDetails']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  paidAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlayerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Player'] = ResolversParentTypes['Player']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  playerSessionId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  released?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sessionNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreviousSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreviousSession'] = ResolversParentTypes['PreviousSession']> = {
  avatar?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  released?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sessionNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProcessOperatorSessionOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProcessOperatorSessionOutput'] = ResolversParentTypes['ProcessOperatorSessionOutput']> = {
  processed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sessionNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  checkEmailExist?: Resolver<ResolversTypes['CheckEmailExistOutput'], ParentType, ContextType, RequireFields<QueryCheckEmailExistArgs, 'input'>>;
  checkEmailExists?: Resolver<ResolversTypes['CheckEmailExistOutput'], ParentType, ContextType, RequireFields<QueryCheckEmailExistsArgs, 'input'>>;
  checkEmailToken?: Resolver<ResolversTypes['CheckEmailTokenOutput'], ParentType, ContextType, RequireFields<QueryCheckEmailTokenArgs, 'checkEmailTokenInput'>>;
  checkUserNameExist?: Resolver<ResolversTypes['CheckUsernameExistOutput'], ParentType, ContextType, RequireFields<QueryCheckUserNameExistArgs, 'input'>>;
  clubs?: Resolver<Array<ResolversTypes['Club']>, ParentType, ContextType, Partial<QueryClubsArgs>>;
  compare?: Resolver<Maybe<ResolversTypes['FoundComparison']>, ParentType, ContextType, RequireFields<QueryCompareArgs, 'compareInput'>>;
  findComparison?: Resolver<Maybe<ResolversTypes['Comparison']>, ParentType, ContextType, RequireFields<QueryFindComparisonArgs, 'findComparisonInput'>>;
  findComparisonOptions?: Resolver<Maybe<ResolversTypes['ComparisonOptions']>, ParentType, ContextType, RequireFields<QueryFindComparisonOptionsArgs, 'findComparisonOptionsInput'>>;
  findEventPlayer?: Resolver<Array<ResolversTypes['EventPlayer']>, ParentType, ContextType, RequireFields<QueryFindEventPlayerArgs, 'eventNumber' | 'search'>>;
  findEventTrainer?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType, RequireFields<QueryFindEventTrainerArgs, 'eventNumber' | 'search'>>;
  findOperatorSessionById?: Resolver<Maybe<ResolversTypes['OperatorSession']>, ParentType, ContextType, RequireFields<QueryFindOperatorSessionByIdArgs, 'sessionNumber'>>;
  findPlayerScore?: Resolver<Maybe<ResolversTypes['Score']>, ParentType, ContextType, RequireFields<QueryFindPlayerScoreArgs, 'playerSessionId' | 'sessionNumber'>>;
  findPlayerScoresByUserId?: Resolver<Array<ResolversTypes['Score']>, ParentType, ContextType, RequireFields<QueryFindPlayerScoresByUserIdArgs, 'userId'>>;
  findPlayers?: Resolver<Maybe<Array<ResolversTypes['Player']>>, ParentType, ContextType, RequireFields<QueryFindPlayersArgs, 'sessionNumber'>>;
  findSession?: Resolver<Maybe<ResolversTypes['Session']>, ParentType, ContextType, RequireFields<QueryFindSessionArgs, 'sessionNumber'>>;
  findSessionsByUserId?: Resolver<Array<ResolversTypes['Session']>, ParentType, ContextType, RequireFields<QueryFindSessionsByUserIdArgs, 'id'>>;
  findVideo?: Resolver<Maybe<ResolversTypes['Video']>, ParentType, ContextType, RequireFields<QueryFindVideoArgs, 'id' | 'sessionNumber'>>;
  findVideos?: Resolver<Array<ResolversTypes['FindVideosOutput']>, ParentType, ContextType, RequireFields<QueryFindVideosArgs, 'role'>>;
  getEmailVerificationToken?: Resolver<ResolversTypes['GetEmailVerificationTokenOutput'], ParentType, ContextType, RequireFields<QueryGetEmailVerificationTokenArgs, 'getEmailVerificationTokenInput'>>;
  getEvent?: Resolver<ResolversTypes['ScoutingEvent'], ParentType, ContextType, RequireFields<QueryGetEventArgs, 'eventNumber'>>;
  getEventSession?: Resolver<ResolversTypes['OperatorSession'], ParentType, ContextType, RequireFields<QueryGetEventSessionArgs, 'eventNumber' | 'sessionNumber'>>;
  getTrainingVideos?: Resolver<Array<ResolversTypes['SubScoreTrainingVideos']>, ParentType, ContextType, RequireFields<QueryGetTrainingVideosArgs, 'playerSessionId' | 'sessionNumber'>>;
  listEventSessions?: Resolver<Array<ResolversTypes['OperatorSession']>, ParentType, ContextType, RequireFields<QueryListEventSessionsArgs, 'eventNumber'>>;
  listEvents?: Resolver<Array<ResolversTypes['ScoutingEvent']>, ParentType, ContextType>;
  notificationKeys?: Resolver<Array<ResolversTypes['NotificationKey']>, ParentType, ContextType>;
  notificationTypes?: Resolver<Array<ResolversTypes['NotificationType']>, ParentType, ContextType>;
  notifications?: Resolver<ResolversTypes['NotificationsOutput'], ParentType, ContextType>;
  operatorSessions?: Resolver<Array<ResolversTypes['OperatorSession']>, ParentType, ContextType>;
  paginatedUsers?: Resolver<ResolversTypes['PaginatedUsersOutput'], ParentType, ContextType, RequireFields<QueryPaginatedUsersArgs, 'paginatedUsersInput'>>;
  playerScores?: Resolver<Array<ResolversTypes['Score']>, ParentType, ContextType, Partial<QueryPlayerScoresArgs>>;
  searchPlayers?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType, RequireFields<QuerySearchPlayersArgs, 'externalSource'>>;
  searchTrainers?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType, RequireFields<QuerySearchTrainersArgs, 'externalSource'>>;
  searchUsers?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType, RequireFields<QuerySearchUsersArgs, 'externalSource' | 'roles'>>;
  sessions?: Resolver<Array<ResolversTypes['Session']>, ParentType, ContextType, Partial<QuerySessionsArgs>>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
  validateCode?: Resolver<ResolversTypes['ValidateCodeOutput'], ParentType, ContextType, RequireFields<QueryValidateCodeArgs, 'code'>>;
  validateEmail?: Resolver<ResolversTypes['ValidateEmailOutput'], ParentType, ContextType, RequireFields<QueryValidateEmailArgs, 'validateEmailInput'>>;
  watchComparisons?: Resolver<Array<ResolversTypes['WatchComparison']>, ParentType, ContextType, RequireFields<QueryWatchComparisonsArgs, 'role'>>;
  watchSessions?: Resolver<Array<ResolversTypes['WatchSession']>, ParentType, ContextType, RequireFields<QueryWatchSessionsArgs, 'role'>>;
};

export type RawDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['RawData'] = ResolversParentTypes['RawData']> = {
  de?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  en?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stringValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unit?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefreshTokenOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefreshTokenOutput'] = ResolversParentTypes['RefreshTokenOutput']> = {
  accessToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  refreshed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReleasePlayerScoreOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReleasePlayerScoreOutput'] = ResolversParentTypes['ReleasePlayerScoreOutput']> = {
  playerSessionId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sessionNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResendExpiredLinkOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResendExpiredLinkOutput'] = ResolversParentTypes['ResendExpiredLinkOutput']> = {
  sent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sub?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResendLegalGuardianEmailOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResendLegalGuardianEmailOutput'] = ResolversParentTypes['ResendLegalGuardianEmailOutput']> = {
  emailSent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  legalGuardianEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResendUserEmailOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResendUserEmailOutput'] = ResolversParentTypes['ResendUserEmailOutput']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  emailSent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResetPasswordOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetPasswordOutput'] = ResolversParentTypes['ResetPasswordOutput']> = {
  passwordChanged?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResetUserPasswordOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetUserPasswordOutput'] = ResolversParentTypes['ResetUserPasswordOutput']> = {
  reset?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScoreResolvers<ContextType = any, ParentType extends ResolversParentTypes['Score'] = ResolversParentTypes['Score']> = {
  ageGroup?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  ageGroupValue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  badgeLevel?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  club?: Resolver<Maybe<ResolversTypes['Club']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  payment?: Resolver<Maybe<ResolversTypes['PaymentDetails']>, ParentType, ContextType>;
  playerSessionId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  released?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  score?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  sessionNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  subScores?: Resolver<Array<ResolversTypes['SubScores']>, ParentType, ContextType>;
  trainers?: Resolver<Maybe<Array<ResolversTypes['User']>>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScoutingEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScoutingEvent'] = ResolversParentTypes['ScoutingEvent']> = {
  club?: Resolver<ResolversTypes['Club'], ParentType, ContextType>;
  end?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  eventNumber?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  externalSources?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  fixedGoalKeepers?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  players?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
  sessions?: Resolver<Array<ResolversTypes['PartialOperatorSession']>, ParentType, ContextType>;
  shotTest?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sprintTest?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  start?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  trainers?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SeparatedDateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SeparatedDate'] = ResolversParentTypes['SeparatedDate']> = {
  day?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  month?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  year?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Session'] = ResolversParentTypes['Session']> = {
  ageGroup?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  ageGroupValue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  averages?: Resolver<Array<ResolversTypes['SubScores']>, ParentType, ContextType>;
  badgeLevel?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  club?: Resolver<Maybe<ResolversTypes['Club']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  playerCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  playerReleased?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  score?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  sessionNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  trainers?: Resolver<Maybe<Array<ResolversTypes['User']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SessionOrScoreResolvers<ContextType = any, ParentType extends ResolversParentTypes['SessionOrScore'] = ResolversParentTypes['SessionOrScore']> = {
  __resolveType: TypeResolveFn<'Score' | 'Session', ParentType, ContextType>;
};

export type SignInOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['SignInOutput'] = ResolversParentTypes['SignInOutput']> = {
  accessToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  refreshToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SignUpOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['SignUpOutput'] = ResolversParentTypes['SignUpOutput']> = {
  accessToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  refreshToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  registered?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubScorePlayersResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubScorePlayers'] = ResolversParentTypes['SubScorePlayers']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  playerSessionId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sub?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubScoreTrainingVideosResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubScoreTrainingVideos'] = ResolversParentTypes['SubScoreTrainingVideos']> = {
  playerSessionId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sessionNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  trainingsVideos?: Resolver<Array<ResolversTypes['TrainingsVideo']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubScoresResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubScores'] = ResolversParentTypes['SubScores']> = {
  bestPlayers?: Resolver<Maybe<Array<ResolversTypes['SubScorePlayers']>>, ParentType, ContextType>;
  counts?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  difference?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rawData?: Resolver<Maybe<Array<ResolversTypes['RawData']>>, ParentType, ContextType>;
  trainingsVideos?: Resolver<Maybe<Array<ResolversTypes['TrainingsVideo']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  worstPlayers?: Resolver<Maybe<Array<ResolversTypes['SubScorePlayers']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SystemNotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SystemNotification'] = ResolversParentTypes['SystemNotification']> = {
  parameters?: Resolver<Array<ResolversTypes['SystemNotificationParameter']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SystemNotificationParameterResolvers<ContextType = any, ParentType extends ResolversParentTypes['SystemNotificationParameter'] = ResolversParentTypes['SystemNotificationParameter']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TextsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Texts'] = ResolversParentTypes['Texts']> = {
  subtext?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TrainingsVideoResolvers<ContextType = any, ParentType extends ResolversParentTypes['TrainingsVideo'] = ResolversParentTypes['TrainingsVideo']> = {
  previewUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  texts?: Resolver<Maybe<ResolversTypes['Texts']>, ParentType, ContextType>;
  thumbnailUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateOperatorSessionOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateOperatorSessionOutput'] = ResolversParentTypes['UpdateOperatorSessionOutput']> = {
  sessionNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateUserAvatarOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUserAvatarOutput'] = ResolversParentTypes['UpdateUserAvatarOutput']> = {
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateUserBackgroundOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUserBackgroundOutput'] = ResolversParentTypes['UpdateUserBackgroundOutput']> = {
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateUserOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUserOutput'] = ResolversParentTypes['UpdateUserOutput']> = {
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateUserPasswordOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUserPasswordOutput'] = ResolversParentTypes['UpdateUserPasswordOutput']> = {
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface UploadScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Upload'], any> {
  name: 'Upload';
}

export type UploadSessionVideoOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadSessionVideoOutput'] = ResolversParentTypes['UploadSessionVideoOutput']> = {
  uploaded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  address?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  avatarTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  backgroundTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  backgroundUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  birthdate?: Resolver<Maybe<ResolversTypes['SeparatedDate']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailVerified?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  externalSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  legalGuardian?: Resolver<Maybe<ResolversTypes['LegalGuardian']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  newsletterSubscription?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  roles?: Resolver<Maybe<Array<ResolversTypes['UserRole']>>, ParentType, ContextType>;
  sub?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidateCodeOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidateCodeOutput'] = ResolversParentTypes['ValidateCodeOutput']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  valid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidateEmailOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidateEmailOutput'] = ResolversParentTypes['ValidateEmailOutput']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  valid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerifyLegalGuardianOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['VerifyLegalGuardianOutput'] = ResolversParentTypes['VerifyLegalGuardianOutput']> = {
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  verified?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerifyUserEmailOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['VerifyUserEmailOutput'] = ResolversParentTypes['VerifyUserEmailOutput']> = {
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  verified?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VideoResolvers<ContextType = any, ParentType extends ResolversParentTypes['Video'] = ResolversParentTypes['Video']> = {
  cookies?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VideoTumbResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoTumb'] = ResolversParentTypes['VideoTumb']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  match?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  thumb?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WatchComparisonResolvers<ContextType = any, ParentType extends ResolversParentTypes['WatchComparison'] = ResolversParentTypes['WatchComparison']> = {
  compareFrom?: Resolver<ResolversTypes['WatchComparisonResult'], ParentType, ContextType>;
  compareTo?: Resolver<ResolversTypes['WatchComparisonResult'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['UserRole'], ParentType, ContextType>;
  sessionNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skill?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sub?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subFrom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['FoundComparisonType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WatchComparisonDeletedOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['WatchComparisonDeletedOutput'] = ResolversParentTypes['WatchComparisonDeletedOutput']> = {
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WatchComparisonResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['WatchComparisonResult'] = ResolversParentTypes['WatchComparisonResult']> = {
  avatar?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sessionNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WatchScoreResolvers<ContextType = any, ParentType extends ResolversParentTypes['WatchScore'] = ResolversParentTypes['WatchScore']> = {
  avatar?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WatchSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['WatchSession'] = ResolversParentTypes['WatchSession']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  playerSessionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['UserRole'], ParentType, ContextType>;
  scoreA?: Resolver<ResolversTypes['WatchScore'], ParentType, ContextType>;
  scoreB?: Resolver<ResolversTypes['WatchScore'], ParentType, ContextType>;
  sessionNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skill?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ComparisonType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WatchSessionDeletedOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['WatchSessionDeletedOutput'] = ResolversParentTypes['WatchSessionDeletedOutput']> = {
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  Address?: AddressResolvers<ContextType>;
  CancelReleasedPlayerScoreOutput?: CancelReleasedPlayerScoreOutputResolvers<ContextType>;
  CheckEmailExistOutput?: CheckEmailExistOutputResolvers<ContextType>;
  CheckEmailTokenOutput?: CheckEmailTokenOutputResolvers<ContextType>;
  CheckUsernameExistOutput?: CheckUsernameExistOutputResolvers<ContextType>;
  Club?: ClubResolvers<ContextType>;
  Comparison?: ComparisonResolvers<ContextType>;
  ComparisonOptions?: ComparisonOptionsResolvers<ContextType>;
  ComparisonScore?: ComparisonScoreResolvers<ContextType>;
  ConfirmLegalGuardianOutput?: ConfirmLegalGuardianOutputResolvers<ContextType>;
  ConfirmUserEmailOutput?: ConfirmUserEmailOutputResolvers<ContextType>;
  CreateOperatorSessionOutput?: CreateOperatorSessionOutputResolvers<ContextType>;
  CreateStripeIntentOutput?: CreateStripeIntentOutputResolvers<ContextType>;
  Date?: GraphQLScalarType;
  DeleteAccountOutput?: DeleteAccountOutputResolvers<ContextType>;
  DeleteOperatorSessionOutput?: DeleteOperatorSessionOutputResolvers<ContextType>;
  EventPlayer?: EventPlayerResolvers<ContextType>;
  FindVideosOutput?: FindVideosOutputResolvers<ContextType>;
  ForgotPasswordOutput?: ForgotPasswordOutputResolvers<ContextType>;
  ForgotUserPasswordOutput?: ForgotUserPasswordOutputResolvers<ContextType>;
  FoundComparison?: FoundComparisonResolvers<ContextType>;
  FoundComparisonScore?: FoundComparisonScoreResolvers<ContextType>;
  GetEmailVerificationTokenOutput?: GetEmailVerificationTokenOutputResolvers<ContextType>;
  Ground?: GroundResolvers<ContextType>;
  LegalGuardian?: LegalGuardianResolvers<ContextType>;
  LogoutOutput?: LogoutOutputResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NotificationsOutput?: NotificationsOutputResolvers<ContextType>;
  OperatorSession?: OperatorSessionResolvers<ContextType>;
  PaginatedUsersOutput?: PaginatedUsersOutputResolvers<ContextType>;
  PartialOperatorSession?: PartialOperatorSessionResolvers<ContextType>;
  PayPlayerSessionWithCardOutput?: PayPlayerSessionWithCardOutputResolvers<ContextType>;
  PayPlayerSessionWithPaypalOutput?: PayPlayerSessionWithPaypalOutputResolvers<ContextType>;
  PaymentDetails?: PaymentDetailsResolvers<ContextType>;
  Player?: PlayerResolvers<ContextType>;
  PreviousSession?: PreviousSessionResolvers<ContextType>;
  ProcessOperatorSessionOutput?: ProcessOperatorSessionOutputResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  RawData?: RawDataResolvers<ContextType>;
  RefreshTokenOutput?: RefreshTokenOutputResolvers<ContextType>;
  ReleasePlayerScoreOutput?: ReleasePlayerScoreOutputResolvers<ContextType>;
  ResendExpiredLinkOutput?: ResendExpiredLinkOutputResolvers<ContextType>;
  ResendLegalGuardianEmailOutput?: ResendLegalGuardianEmailOutputResolvers<ContextType>;
  ResendUserEmailOutput?: ResendUserEmailOutputResolvers<ContextType>;
  ResetPasswordOutput?: ResetPasswordOutputResolvers<ContextType>;
  ResetUserPasswordOutput?: ResetUserPasswordOutputResolvers<ContextType>;
  Score?: ScoreResolvers<ContextType>;
  ScoutingEvent?: ScoutingEventResolvers<ContextType>;
  SeparatedDate?: SeparatedDateResolvers<ContextType>;
  Session?: SessionResolvers<ContextType>;
  SessionOrScore?: SessionOrScoreResolvers<ContextType>;
  SignInOutput?: SignInOutputResolvers<ContextType>;
  SignUpOutput?: SignUpOutputResolvers<ContextType>;
  SubScorePlayers?: SubScorePlayersResolvers<ContextType>;
  SubScoreTrainingVideos?: SubScoreTrainingVideosResolvers<ContextType>;
  SubScores?: SubScoresResolvers<ContextType>;
  SystemNotification?: SystemNotificationResolvers<ContextType>;
  SystemNotificationParameter?: SystemNotificationParameterResolvers<ContextType>;
  Texts?: TextsResolvers<ContextType>;
  TrainingsVideo?: TrainingsVideoResolvers<ContextType>;
  UpdateOperatorSessionOutput?: UpdateOperatorSessionOutputResolvers<ContextType>;
  UpdateUserAvatarOutput?: UpdateUserAvatarOutputResolvers<ContextType>;
  UpdateUserBackgroundOutput?: UpdateUserBackgroundOutputResolvers<ContextType>;
  UpdateUserOutput?: UpdateUserOutputResolvers<ContextType>;
  UpdateUserPasswordOutput?: UpdateUserPasswordOutputResolvers<ContextType>;
  Upload?: GraphQLScalarType;
  UploadSessionVideoOutput?: UploadSessionVideoOutputResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  ValidateCodeOutput?: ValidateCodeOutputResolvers<ContextType>;
  ValidateEmailOutput?: ValidateEmailOutputResolvers<ContextType>;
  VerifyLegalGuardianOutput?: VerifyLegalGuardianOutputResolvers<ContextType>;
  VerifyUserEmailOutput?: VerifyUserEmailOutputResolvers<ContextType>;
  Video?: VideoResolvers<ContextType>;
  VideoTumb?: VideoTumbResolvers<ContextType>;
  WatchComparison?: WatchComparisonResolvers<ContextType>;
  WatchComparisonDeletedOutput?: WatchComparisonDeletedOutputResolvers<ContextType>;
  WatchComparisonResult?: WatchComparisonResultResolvers<ContextType>;
  WatchScore?: WatchScoreResolvers<ContextType>;
  WatchSession?: WatchSessionResolvers<ContextType>;
  WatchSessionDeletedOutput?: WatchSessionDeletedOutputResolvers<ContextType>;
};


export const OperatorSessionFragmentFragmentDoc = gql`
    fragment OperatorSessionFragment on OperatorSession {
  sessionNumber
  ageGroup
  club {
    id
    name
  }
  fixedGoalkeepers
  sprintTest
  shotTest
  playersCount
  trainersCount
  matchesCount
  processed
  scored
  date
  allVideosUploaded
  videosUploaded
  ground {
    width
    height
    goalWidth
    goalHeight
  }
}
    `;
export const PartialOperatorSessionFragmentFragmentDoc = gql`
    fragment PartialOperatorSessionFragment on PartialOperatorSession {
  sessionNumber
  ageGroup
  club {
    id
    name
  }
  fixedGoalkeepers
  sprintTest
  shotTest
  playersCount
  trainersCount
  matchesCount
  processed
  scored
  date
  allVideosUploaded
  videosUploaded
  ground {
    width
    height
    goalWidth
    goalHeight
  }
}
    `;
export const UserFragmentFragmentDoc = gql`
    fragment UserFragment on User {
  sub
  username
  email
  name
  firstName
  lastName
  birthdate {
    day
    month
    year
  }
  avatarUrl
  backgroundUrl
  roles
  emailVerified
  newsletterSubscription
  externalSource
  legalGuardian {
    email
    firstName
    lastName
    phone
    consent
    birthdate {
      day
      month
      year
    }
  }
}
    `;
export const PlayerScoreFragmentFragmentDoc = gql`
    fragment PlayerScoreFragment on Score {
  trainers {
    ...UserFragment
  }
  playerSessionId
  sessionNumber
  score
  badgeLevel
  ageGroup
  ageGroupValue
  date
  released
  payment {
    id
    amount
    currency
    paidAt
  }
  user {
    ...UserFragment
  }
  subScores {
    type
    value
    rawData {
      name
      unit
      value
      stringValue
    }
  }
  club {
    id
    logoUrl
    city
    country
    name
    street
  }
}
    ${UserFragmentFragmentDoc}`;
export const TrainerSessionFragmentFragmentDoc = gql`
    fragment TrainerSessionFragment on Session {
  sessionNumber
  ageGroup
  ageGroupValue
  date
  score
  badgeLevel
  playerCount
  playerReleased
  trainers {
    ...UserFragment
  }
  club {
    id
    logoUrl
    city
    country
    name
    street
  }
  averages {
    type
    value
    rawData {
      name
      unit
      value
      stringValue
    }
    bestPlayers {
      playerSessionId
      avatarUrl
      value
      sub
    }
    worstPlayers {
      playerSessionId
      avatarUrl
      value
      sub
    }
  }
}
    ${UserFragmentFragmentDoc}`;
export const AddCodeDocument = gql`
    mutation addCode($input: AddCodeInput!) {
  addCode(addCodeInput: $input) {
    __typename
    ... on Session {
      sessionNumber
    }
    ... on Score {
      user {
        email
        firstName
        lastName
      }
      date
      playerSessionId
      payment {
        paidAt
        amount
        currency
        id
      }
      sessionNumber
    }
  }
}
    `;
export type AddCodeMutationFn = Apollo.MutationFunction<AddCodeMutation, AddCodeMutationVariables>;

/**
 * __useAddCodeMutation__
 *
 * To run a mutation, you first call `useAddCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCodeMutation, { data, loading, error }] = useAddCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCodeMutation(baseOptions?: Apollo.MutationHookOptions<AddCodeMutation, AddCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCodeMutation, AddCodeMutationVariables>(AddCodeDocument, options);
      }
export type AddCodeMutationHookResult = ReturnType<typeof useAddCodeMutation>;
export type AddCodeMutationResult = Apollo.MutationResult<AddCodeMutation>;
export type AddCodeMutationOptions = Apollo.BaseMutationOptions<AddCodeMutation, AddCodeMutationVariables>;
export const CancelReleasedPlayerScoreDocument = gql`
    mutation cancelReleasedPlayerScore($input: CancelReleasedPlayerScoreInput!) {
  cancelReleasedPlayerScore(cancelReleasedPlayerScoreInput: $input) {
    playerSessionId
    sessionNumber
  }
}
    `;
export type CancelReleasedPlayerScoreMutationFn = Apollo.MutationFunction<CancelReleasedPlayerScoreMutation, CancelReleasedPlayerScoreMutationVariables>;

/**
 * __useCancelReleasedPlayerScoreMutation__
 *
 * To run a mutation, you first call `useCancelReleasedPlayerScoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelReleasedPlayerScoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelReleasedPlayerScoreMutation, { data, loading, error }] = useCancelReleasedPlayerScoreMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelReleasedPlayerScoreMutation(baseOptions?: Apollo.MutationHookOptions<CancelReleasedPlayerScoreMutation, CancelReleasedPlayerScoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelReleasedPlayerScoreMutation, CancelReleasedPlayerScoreMutationVariables>(CancelReleasedPlayerScoreDocument, options);
      }
export type CancelReleasedPlayerScoreMutationHookResult = ReturnType<typeof useCancelReleasedPlayerScoreMutation>;
export type CancelReleasedPlayerScoreMutationResult = Apollo.MutationResult<CancelReleasedPlayerScoreMutation>;
export type CancelReleasedPlayerScoreMutationOptions = Apollo.BaseMutationOptions<CancelReleasedPlayerScoreMutation, CancelReleasedPlayerScoreMutationVariables>;
export const ConfirmLegalGuardianDocument = gql`
    mutation confirmLegalGuardian($input: ConfirmLegalGuardianInput!) {
  confirmLegalGuardian(confirmLegalGuardianInput: $input) {
    confirmed
    user {
      ...UserFragment
    }
  }
}
    ${UserFragmentFragmentDoc}`;
export type ConfirmLegalGuardianMutationFn = Apollo.MutationFunction<ConfirmLegalGuardianMutation, ConfirmLegalGuardianMutationVariables>;

/**
 * __useConfirmLegalGuardianMutation__
 *
 * To run a mutation, you first call `useConfirmLegalGuardianMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmLegalGuardianMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmLegalGuardianMutation, { data, loading, error }] = useConfirmLegalGuardianMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmLegalGuardianMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmLegalGuardianMutation, ConfirmLegalGuardianMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmLegalGuardianMutation, ConfirmLegalGuardianMutationVariables>(ConfirmLegalGuardianDocument, options);
      }
export type ConfirmLegalGuardianMutationHookResult = ReturnType<typeof useConfirmLegalGuardianMutation>;
export type ConfirmLegalGuardianMutationResult = Apollo.MutationResult<ConfirmLegalGuardianMutation>;
export type ConfirmLegalGuardianMutationOptions = Apollo.BaseMutationOptions<ConfirmLegalGuardianMutation, ConfirmLegalGuardianMutationVariables>;
export const CreateClubDocument = gql`
    mutation createClub($input: CreateClubInput!) {
  createClub(createClubInput: $input) {
    id
    city
    country
    logoUrl
    name
    street
  }
}
    `;
export type CreateClubMutationFn = Apollo.MutationFunction<CreateClubMutation, CreateClubMutationVariables>;

/**
 * __useCreateClubMutation__
 *
 * To run a mutation, you first call `useCreateClubMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClubMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClubMutation, { data, loading, error }] = useCreateClubMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClubMutation(baseOptions?: Apollo.MutationHookOptions<CreateClubMutation, CreateClubMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClubMutation, CreateClubMutationVariables>(CreateClubDocument, options);
      }
export type CreateClubMutationHookResult = ReturnType<typeof useCreateClubMutation>;
export type CreateClubMutationResult = Apollo.MutationResult<CreateClubMutation>;
export type CreateClubMutationOptions = Apollo.BaseMutationOptions<CreateClubMutation, CreateClubMutationVariables>;
export const CreateEventDocument = gql`
    mutation createEvent($input: CreateScoutingEventInput!) {
  createEvent(createScoutingEventInput: $input) {
    name
    start
    end
    fixedGoalKeepers
    sprintTest
    shotTest
    club {
      id
      name
    }
  }
}
    `;
export type CreateEventMutationFn = Apollo.MutationFunction<CreateEventMutation, CreateEventMutationVariables>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventMutation, CreateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventMutation, CreateEventMutationVariables>(CreateEventDocument, options);
      }
export type CreateEventMutationHookResult = ReturnType<typeof useCreateEventMutation>;
export type CreateEventMutationResult = Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<CreateEventMutation, CreateEventMutationVariables>;
export const CreateEventSessionDocument = gql`
    mutation createEventSession($eventNumber: Int!, $args: CreateOperatorSessionInput!) {
  createEventSession(eventNumber: $eventNumber, args: $args) {
    sessionNumber
    ageGroup
    fixedGoalkeepers
    playersCount
    trainersCount
    matchesCount
  }
}
    `;
export type CreateEventSessionMutationFn = Apollo.MutationFunction<CreateEventSessionMutation, CreateEventSessionMutationVariables>;

/**
 * __useCreateEventSessionMutation__
 *
 * To run a mutation, you first call `useCreateEventSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventSessionMutation, { data, loading, error }] = useCreateEventSessionMutation({
 *   variables: {
 *      eventNumber: // value for 'eventNumber'
 *      args: // value for 'args'
 *   },
 * });
 */
export function useCreateEventSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventSessionMutation, CreateEventSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventSessionMutation, CreateEventSessionMutationVariables>(CreateEventSessionDocument, options);
      }
export type CreateEventSessionMutationHookResult = ReturnType<typeof useCreateEventSessionMutation>;
export type CreateEventSessionMutationResult = Apollo.MutationResult<CreateEventSessionMutation>;
export type CreateEventSessionMutationOptions = Apollo.BaseMutationOptions<CreateEventSessionMutation, CreateEventSessionMutationVariables>;
export const CreateOperatorSessionDocument = gql`
    mutation createOperatorSession($input: CreateOperatorSessionInput!) {
  createOperatorSession(createOperatorSessionInput: $input) {
    sessionNumber
    created
  }
}
    `;
export type CreateOperatorSessionMutationFn = Apollo.MutationFunction<CreateOperatorSessionMutation, CreateOperatorSessionMutationVariables>;

/**
 * __useCreateOperatorSessionMutation__
 *
 * To run a mutation, you first call `useCreateOperatorSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOperatorSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOperatorSessionMutation, { data, loading, error }] = useCreateOperatorSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOperatorSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateOperatorSessionMutation, CreateOperatorSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOperatorSessionMutation, CreateOperatorSessionMutationVariables>(CreateOperatorSessionDocument, options);
      }
export type CreateOperatorSessionMutationHookResult = ReturnType<typeof useCreateOperatorSessionMutation>;
export type CreateOperatorSessionMutationResult = Apollo.MutationResult<CreateOperatorSessionMutation>;
export type CreateOperatorSessionMutationOptions = Apollo.BaseMutationOptions<CreateOperatorSessionMutation, CreateOperatorSessionMutationVariables>;
export const CreateStripeIntentDocument = gql`
    mutation createStripeIntent($input: CreateStripeIntentInput!) {
  createStripeIntent(createStripeIntentInput: $input) {
    stripeId
    pubKey
    clientSecret
    fresh
  }
}
    `;
export type CreateStripeIntentMutationFn = Apollo.MutationFunction<CreateStripeIntentMutation, CreateStripeIntentMutationVariables>;

/**
 * __useCreateStripeIntentMutation__
 *
 * To run a mutation, you first call `useCreateStripeIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStripeIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStripeIntentMutation, { data, loading, error }] = useCreateStripeIntentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStripeIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreateStripeIntentMutation, CreateStripeIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStripeIntentMutation, CreateStripeIntentMutationVariables>(CreateStripeIntentDocument, options);
      }
export type CreateStripeIntentMutationHookResult = ReturnType<typeof useCreateStripeIntentMutation>;
export type CreateStripeIntentMutationResult = Apollo.MutationResult<CreateStripeIntentMutation>;
export type CreateStripeIntentMutationOptions = Apollo.BaseMutationOptions<CreateStripeIntentMutation, CreateStripeIntentMutationVariables>;
export const CreateWatchComparisonDocument = gql`
    mutation createWatchComparison($input: WatchComparisonInput!) {
  createWatchComparison(createWatchComparisonInput: $input) {
    id
    role
    skill
    type
    sessionNumber
    subFrom
    sub
    compareFrom {
      name
      sessionNumber
      avatar
      date
      value
    }
    compareTo {
      name
      sessionNumber
      avatar
      date
      value
    }
  }
}
    `;
export type CreateWatchComparisonMutationFn = Apollo.MutationFunction<CreateWatchComparisonMutation, CreateWatchComparisonMutationVariables>;

/**
 * __useCreateWatchComparisonMutation__
 *
 * To run a mutation, you first call `useCreateWatchComparisonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWatchComparisonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWatchComparisonMutation, { data, loading, error }] = useCreateWatchComparisonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWatchComparisonMutation(baseOptions?: Apollo.MutationHookOptions<CreateWatchComparisonMutation, CreateWatchComparisonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWatchComparisonMutation, CreateWatchComparisonMutationVariables>(CreateWatchComparisonDocument, options);
      }
export type CreateWatchComparisonMutationHookResult = ReturnType<typeof useCreateWatchComparisonMutation>;
export type CreateWatchComparisonMutationResult = Apollo.MutationResult<CreateWatchComparisonMutation>;
export type CreateWatchComparisonMutationOptions = Apollo.BaseMutationOptions<CreateWatchComparisonMutation, CreateWatchComparisonMutationVariables>;
export const DeleteAccountDocument = gql`
    mutation deleteAccount($input: DeleteAccountInput!) {
  deleteAccount(deleteAccountInput: $input) {
    sub
    deleted
  }
}
    `;
export type DeleteAccountMutationFn = Apollo.MutationFunction<DeleteAccountMutation, DeleteAccountMutationVariables>;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountMutation, DeleteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument, options);
      }
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = Apollo.MutationResult<DeleteAccountMutation>;
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<DeleteAccountMutation, DeleteAccountMutationVariables>;
export const DeleteEventDocument = gql`
    mutation deleteEvent($eventNumber: Int!) {
  deleteEvent(eventNumber: $eventNumber)
}
    `;
export type DeleteEventMutationFn = Apollo.MutationFunction<DeleteEventMutation, DeleteEventMutationVariables>;

/**
 * __useDeleteEventMutation__
 *
 * To run a mutation, you first call `useDeleteEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventMutation, { data, loading, error }] = useDeleteEventMutation({
 *   variables: {
 *      eventNumber: // value for 'eventNumber'
 *   },
 * });
 */
export function useDeleteEventMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventMutation, DeleteEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventMutation, DeleteEventMutationVariables>(DeleteEventDocument, options);
      }
export type DeleteEventMutationHookResult = ReturnType<typeof useDeleteEventMutation>;
export type DeleteEventMutationResult = Apollo.MutationResult<DeleteEventMutation>;
export type DeleteEventMutationOptions = Apollo.BaseMutationOptions<DeleteEventMutation, DeleteEventMutationVariables>;
export const DeleteEventSessionDocument = gql`
    mutation deleteEventSession($eventNumber: Int!, $sessionNumber: Int!) {
  deleteEventSession(eventNumber: $eventNumber, sessionNumber: $sessionNumber)
}
    `;
export type DeleteEventSessionMutationFn = Apollo.MutationFunction<DeleteEventSessionMutation, DeleteEventSessionMutationVariables>;

/**
 * __useDeleteEventSessionMutation__
 *
 * To run a mutation, you first call `useDeleteEventSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventSessionMutation, { data, loading, error }] = useDeleteEventSessionMutation({
 *   variables: {
 *      eventNumber: // value for 'eventNumber'
 *      sessionNumber: // value for 'sessionNumber'
 *   },
 * });
 */
export function useDeleteEventSessionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventSessionMutation, DeleteEventSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventSessionMutation, DeleteEventSessionMutationVariables>(DeleteEventSessionDocument, options);
      }
export type DeleteEventSessionMutationHookResult = ReturnType<typeof useDeleteEventSessionMutation>;
export type DeleteEventSessionMutationResult = Apollo.MutationResult<DeleteEventSessionMutation>;
export type DeleteEventSessionMutationOptions = Apollo.BaseMutationOptions<DeleteEventSessionMutation, DeleteEventSessionMutationVariables>;
export const DeleteOperatorSessionDocument = gql`
    mutation deleteOperatorSession($sessionNumber: Int!) {
  deleteOperatorSession(sessionNumber: $sessionNumber) {
    sessionNumber
    deleted
  }
}
    `;
export type DeleteOperatorSessionMutationFn = Apollo.MutationFunction<DeleteOperatorSessionMutation, DeleteOperatorSessionMutationVariables>;

/**
 * __useDeleteOperatorSessionMutation__
 *
 * To run a mutation, you first call `useDeleteOperatorSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOperatorSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOperatorSessionMutation, { data, loading, error }] = useDeleteOperatorSessionMutation({
 *   variables: {
 *      sessionNumber: // value for 'sessionNumber'
 *   },
 * });
 */
export function useDeleteOperatorSessionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOperatorSessionMutation, DeleteOperatorSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOperatorSessionMutation, DeleteOperatorSessionMutationVariables>(DeleteOperatorSessionDocument, options);
      }
export type DeleteOperatorSessionMutationHookResult = ReturnType<typeof useDeleteOperatorSessionMutation>;
export type DeleteOperatorSessionMutationResult = Apollo.MutationResult<DeleteOperatorSessionMutation>;
export type DeleteOperatorSessionMutationOptions = Apollo.BaseMutationOptions<DeleteOperatorSessionMutation, DeleteOperatorSessionMutationVariables>;
export const DeleteWatchComparisonDocument = gql`
    mutation deleteWatchComparison($input: WatchComparisonInput!) {
  deleteWatchComparison(deleteWatchComparisonInput: $input) {
    deleted
  }
}
    `;
export type DeleteWatchComparisonMutationFn = Apollo.MutationFunction<DeleteWatchComparisonMutation, DeleteWatchComparisonMutationVariables>;

/**
 * __useDeleteWatchComparisonMutation__
 *
 * To run a mutation, you first call `useDeleteWatchComparisonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWatchComparisonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWatchComparisonMutation, { data, loading, error }] = useDeleteWatchComparisonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteWatchComparisonMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWatchComparisonMutation, DeleteWatchComparisonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWatchComparisonMutation, DeleteWatchComparisonMutationVariables>(DeleteWatchComparisonDocument, options);
      }
export type DeleteWatchComparisonMutationHookResult = ReturnType<typeof useDeleteWatchComparisonMutation>;
export type DeleteWatchComparisonMutationResult = Apollo.MutationResult<DeleteWatchComparisonMutation>;
export type DeleteWatchComparisonMutationOptions = Apollo.BaseMutationOptions<DeleteWatchComparisonMutation, DeleteWatchComparisonMutationVariables>;
export const ForgotUserPasswordDocument = gql`
    mutation forgotUserPassword($input: ForgotUserPasswordInput!) {
  forgotUserPassword(forgotUserPasswordInput: $input) {
    email
    emailSent
  }
}
    `;
export type ForgotUserPasswordMutationFn = Apollo.MutationFunction<ForgotUserPasswordMutation, ForgotUserPasswordMutationVariables>;

/**
 * __useForgotUserPasswordMutation__
 *
 * To run a mutation, you first call `useForgotUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotUserPasswordMutation, { data, loading, error }] = useForgotUserPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useForgotUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotUserPasswordMutation, ForgotUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotUserPasswordMutation, ForgotUserPasswordMutationVariables>(ForgotUserPasswordDocument, options);
      }
export type ForgotUserPasswordMutationHookResult = ReturnType<typeof useForgotUserPasswordMutation>;
export type ForgotUserPasswordMutationResult = Apollo.MutationResult<ForgotUserPasswordMutation>;
export type ForgotUserPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotUserPasswordMutation, ForgotUserPasswordMutationVariables>;
export const LogoutDocument = gql`
    mutation logout($input: LogoutInput!) {
  logout(logoutInput: $input) {
    sub
    logout
  }
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const PayPlayerSessionWithCardDocument = gql`
    mutation payPlayerSessionWithCard($input: PayPlayerSessionWithCardInput!) {
  payPlayerSessionWithCard(payPlayerSessionWithCardInput: $input) {
    playerSessionId
    sessionNumber
    paidAt
  }
}
    `;
export type PayPlayerSessionWithCardMutationFn = Apollo.MutationFunction<PayPlayerSessionWithCardMutation, PayPlayerSessionWithCardMutationVariables>;

/**
 * __usePayPlayerSessionWithCardMutation__
 *
 * To run a mutation, you first call `usePayPlayerSessionWithCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayPlayerSessionWithCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payPlayerSessionWithCardMutation, { data, loading, error }] = usePayPlayerSessionWithCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePayPlayerSessionWithCardMutation(baseOptions?: Apollo.MutationHookOptions<PayPlayerSessionWithCardMutation, PayPlayerSessionWithCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayPlayerSessionWithCardMutation, PayPlayerSessionWithCardMutationVariables>(PayPlayerSessionWithCardDocument, options);
      }
export type PayPlayerSessionWithCardMutationHookResult = ReturnType<typeof usePayPlayerSessionWithCardMutation>;
export type PayPlayerSessionWithCardMutationResult = Apollo.MutationResult<PayPlayerSessionWithCardMutation>;
export type PayPlayerSessionWithCardMutationOptions = Apollo.BaseMutationOptions<PayPlayerSessionWithCardMutation, PayPlayerSessionWithCardMutationVariables>;
export const PayPlayerSessionWithPaypalDocument = gql`
    mutation payPlayerSessionWithPaypal($input: PayPlayerSessionWithPaypalInput!) {
  payPlayerSessionWithPaypal(payPlayerSessionWithPaypalInput: $input) {
    playerSessionId
    sessionNumber
    paidAt
  }
}
    `;
export type PayPlayerSessionWithPaypalMutationFn = Apollo.MutationFunction<PayPlayerSessionWithPaypalMutation, PayPlayerSessionWithPaypalMutationVariables>;

/**
 * __usePayPlayerSessionWithPaypalMutation__
 *
 * To run a mutation, you first call `usePayPlayerSessionWithPaypalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayPlayerSessionWithPaypalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payPlayerSessionWithPaypalMutation, { data, loading, error }] = usePayPlayerSessionWithPaypalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePayPlayerSessionWithPaypalMutation(baseOptions?: Apollo.MutationHookOptions<PayPlayerSessionWithPaypalMutation, PayPlayerSessionWithPaypalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayPlayerSessionWithPaypalMutation, PayPlayerSessionWithPaypalMutationVariables>(PayPlayerSessionWithPaypalDocument, options);
      }
export type PayPlayerSessionWithPaypalMutationHookResult = ReturnType<typeof usePayPlayerSessionWithPaypalMutation>;
export type PayPlayerSessionWithPaypalMutationResult = Apollo.MutationResult<PayPlayerSessionWithPaypalMutation>;
export type PayPlayerSessionWithPaypalMutationOptions = Apollo.BaseMutationOptions<PayPlayerSessionWithPaypalMutation, PayPlayerSessionWithPaypalMutationVariables>;
export const ProcessOperatorSessionDocument = gql`
    mutation processOperatorSession($input: ProcessOperatorSessionInput!) {
  processOperatorSession(processOperatorSessionInput: $input) {
    sessionNumber
    processed
  }
}
    `;
export type ProcessOperatorSessionMutationFn = Apollo.MutationFunction<ProcessOperatorSessionMutation, ProcessOperatorSessionMutationVariables>;

/**
 * __useProcessOperatorSessionMutation__
 *
 * To run a mutation, you first call `useProcessOperatorSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessOperatorSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processOperatorSessionMutation, { data, loading, error }] = useProcessOperatorSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProcessOperatorSessionMutation(baseOptions?: Apollo.MutationHookOptions<ProcessOperatorSessionMutation, ProcessOperatorSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessOperatorSessionMutation, ProcessOperatorSessionMutationVariables>(ProcessOperatorSessionDocument, options);
      }
export type ProcessOperatorSessionMutationHookResult = ReturnType<typeof useProcessOperatorSessionMutation>;
export type ProcessOperatorSessionMutationResult = Apollo.MutationResult<ProcessOperatorSessionMutation>;
export type ProcessOperatorSessionMutationOptions = Apollo.BaseMutationOptions<ProcessOperatorSessionMutation, ProcessOperatorSessionMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation refreshToken($input: RefreshTokenInput!) {
  refreshToken(refreshTokenInput: $input) {
    accessToken
    refreshed
  }
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<RefreshTokenMutation, RefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const ReleasePlayerScoreDocument = gql`
    mutation releasePlayerScore($input: ReleasePlayerScoreInput!) {
  releasePlayerScore(releasePlayerScoreInput: $input) {
    playerSessionId
    sessionNumber
  }
}
    `;
export type ReleasePlayerScoreMutationFn = Apollo.MutationFunction<ReleasePlayerScoreMutation, ReleasePlayerScoreMutationVariables>;

/**
 * __useReleasePlayerScoreMutation__
 *
 * To run a mutation, you first call `useReleasePlayerScoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleasePlayerScoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releasePlayerScoreMutation, { data, loading, error }] = useReleasePlayerScoreMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReleasePlayerScoreMutation(baseOptions?: Apollo.MutationHookOptions<ReleasePlayerScoreMutation, ReleasePlayerScoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReleasePlayerScoreMutation, ReleasePlayerScoreMutationVariables>(ReleasePlayerScoreDocument, options);
      }
export type ReleasePlayerScoreMutationHookResult = ReturnType<typeof useReleasePlayerScoreMutation>;
export type ReleasePlayerScoreMutationResult = Apollo.MutationResult<ReleasePlayerScoreMutation>;
export type ReleasePlayerScoreMutationOptions = Apollo.BaseMutationOptions<ReleasePlayerScoreMutation, ReleasePlayerScoreMutationVariables>;
export const ResendExpiredLinkDocument = gql`
    mutation resendExpiredLink($input: ResendExpiredLinkInput!) {
  resendExpiredLink(resendExpiredLinkInput: $input) {
    type
    uuid
    sub
    sent
  }
}
    `;
export type ResendExpiredLinkMutationFn = Apollo.MutationFunction<ResendExpiredLinkMutation, ResendExpiredLinkMutationVariables>;

/**
 * __useResendExpiredLinkMutation__
 *
 * To run a mutation, you first call `useResendExpiredLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendExpiredLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendExpiredLinkMutation, { data, loading, error }] = useResendExpiredLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendExpiredLinkMutation(baseOptions?: Apollo.MutationHookOptions<ResendExpiredLinkMutation, ResendExpiredLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendExpiredLinkMutation, ResendExpiredLinkMutationVariables>(ResendExpiredLinkDocument, options);
      }
export type ResendExpiredLinkMutationHookResult = ReturnType<typeof useResendExpiredLinkMutation>;
export type ResendExpiredLinkMutationResult = Apollo.MutationResult<ResendExpiredLinkMutation>;
export type ResendExpiredLinkMutationOptions = Apollo.BaseMutationOptions<ResendExpiredLinkMutation, ResendExpiredLinkMutationVariables>;
export const ResendLegalGuardianEmailDocument = gql`
    mutation resendLegalGuardianEmail($input: ResendLegalGuardianEmailInput!) {
  resendLegalGuardianEmail(resendLegalGuardianEmailInput: $input) {
    legalGuardianEmail
    emailSent
  }
}
    `;
export type ResendLegalGuardianEmailMutationFn = Apollo.MutationFunction<ResendLegalGuardianEmailMutation, ResendLegalGuardianEmailMutationVariables>;

/**
 * __useResendLegalGuardianEmailMutation__
 *
 * To run a mutation, you first call `useResendLegalGuardianEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendLegalGuardianEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendLegalGuardianEmailMutation, { data, loading, error }] = useResendLegalGuardianEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendLegalGuardianEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendLegalGuardianEmailMutation, ResendLegalGuardianEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendLegalGuardianEmailMutation, ResendLegalGuardianEmailMutationVariables>(ResendLegalGuardianEmailDocument, options);
      }
export type ResendLegalGuardianEmailMutationHookResult = ReturnType<typeof useResendLegalGuardianEmailMutation>;
export type ResendLegalGuardianEmailMutationResult = Apollo.MutationResult<ResendLegalGuardianEmailMutation>;
export type ResendLegalGuardianEmailMutationOptions = Apollo.BaseMutationOptions<ResendLegalGuardianEmailMutation, ResendLegalGuardianEmailMutationVariables>;
export const ResendUserEmailDocument = gql`
    mutation resendUserEmail($input: ResendUserEmailInput!) {
  resendUserEmail(resendUserEmailInput: $input) {
    email
    emailSent
  }
}
    `;
export type ResendUserEmailMutationFn = Apollo.MutationFunction<ResendUserEmailMutation, ResendUserEmailMutationVariables>;

/**
 * __useResendUserEmailMutation__
 *
 * To run a mutation, you first call `useResendUserEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendUserEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendUserEmailMutation, { data, loading, error }] = useResendUserEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendUserEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendUserEmailMutation, ResendUserEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendUserEmailMutation, ResendUserEmailMutationVariables>(ResendUserEmailDocument, options);
      }
export type ResendUserEmailMutationHookResult = ReturnType<typeof useResendUserEmailMutation>;
export type ResendUserEmailMutationResult = Apollo.MutationResult<ResendUserEmailMutation>;
export type ResendUserEmailMutationOptions = Apollo.BaseMutationOptions<ResendUserEmailMutation, ResendUserEmailMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($input: ResetPasswordInput!) {
  resetPassword(resetPasswordInput: $input) {
    username
    passwordChanged
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const ResetUserPasswordDocument = gql`
    mutation resetUserPassword($input: ResetUserPasswordInput!) {
  resetUserPassword(resetUserPasswordInput: $input) {
    user {
      ...UserFragment
    }
    reset
  }
}
    ${UserFragmentFragmentDoc}`;
export type ResetUserPasswordMutationFn = Apollo.MutationFunction<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;

/**
 * __useResetUserPasswordMutation__
 *
 * To run a mutation, you first call `useResetUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetUserPasswordMutation, { data, loading, error }] = useResetUserPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>(ResetUserPasswordDocument, options);
      }
export type ResetUserPasswordMutationHookResult = ReturnType<typeof useResetUserPasswordMutation>;
export type ResetUserPasswordMutationResult = Apollo.MutationResult<ResetUserPasswordMutation>;
export type ResetUserPasswordMutationOptions = Apollo.BaseMutationOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;
export const SignInDocument = gql`
    mutation signIn($input: SignInInput!) {
  signIn(signInInput: $input) {
    accessToken
    refreshToken
    user {
      ...UserFragment
    }
  }
}
    ${UserFragmentFragmentDoc}`;
export type SignInMutationFn = Apollo.MutationFunction<SignInMutation, SignInMutationVariables>;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignInMutation(baseOptions?: Apollo.MutationHookOptions<SignInMutation, SignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInMutation, SignInMutationVariables>(SignInDocument, options);
      }
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>;
export type SignInMutationResult = Apollo.MutationResult<SignInMutation>;
export type SignInMutationOptions = Apollo.BaseMutationOptions<SignInMutation, SignInMutationVariables>;
export const SignUpDocument = gql`
    mutation signUp($input: SignUpInput!) {
  signUp(signUpInput: $input) {
    registered
    user {
      ...UserFragment
    }
    accessToken
    refreshToken
  }
}
    ${UserFragmentFragmentDoc}`;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SignUpMutation, SignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>;
export const UpdateEventDocument = gql`
    mutation updateEvent($input: UpdateScoutingEventInput!) {
  updateEvent(updateScoutingEventInput: $input) {
    eventNumber
    name
    club {
      id
      name
    }
    start
    end
    fixedGoalKeepers
    shotTest
    sprintTest
  }
}
    `;
export type UpdateEventMutationFn = Apollo.MutationFunction<UpdateEventMutation, UpdateEventMutationVariables>;

/**
 * __useUpdateEventMutation__
 *
 * To run a mutation, you first call `useUpdateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventMutation, { data, loading, error }] = useUpdateEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventMutation, UpdateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventMutation, UpdateEventMutationVariables>(UpdateEventDocument, options);
      }
export type UpdateEventMutationHookResult = ReturnType<typeof useUpdateEventMutation>;
export type UpdateEventMutationResult = Apollo.MutationResult<UpdateEventMutation>;
export type UpdateEventMutationOptions = Apollo.BaseMutationOptions<UpdateEventMutation, UpdateEventMutationVariables>;
export const UpdateEventSessionDocument = gql`
    mutation updateEventSession($eventNumber: Int!, $session: UpdateOperatorSessionInput!) {
  UpdateEventSession(eventNumber: $eventNumber, session: $session) {
    sessionNumber
    ageGroup
    fixedGoalkeepers
    playersCount
    trainersCount
    matchesCount
  }
}
    `;
export type UpdateEventSessionMutationFn = Apollo.MutationFunction<UpdateEventSessionMutation, UpdateEventSessionMutationVariables>;

/**
 * __useUpdateEventSessionMutation__
 *
 * To run a mutation, you first call `useUpdateEventSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventSessionMutation, { data, loading, error }] = useUpdateEventSessionMutation({
 *   variables: {
 *      eventNumber: // value for 'eventNumber'
 *      session: // value for 'session'
 *   },
 * });
 */
export function useUpdateEventSessionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventSessionMutation, UpdateEventSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventSessionMutation, UpdateEventSessionMutationVariables>(UpdateEventSessionDocument, options);
      }
export type UpdateEventSessionMutationHookResult = ReturnType<typeof useUpdateEventSessionMutation>;
export type UpdateEventSessionMutationResult = Apollo.MutationResult<UpdateEventSessionMutation>;
export type UpdateEventSessionMutationOptions = Apollo.BaseMutationOptions<UpdateEventSessionMutation, UpdateEventSessionMutationVariables>;
export const UpdateOperatorSessionDocument = gql`
    mutation updateOperatorSession($input: UpdateOperatorSessionInput!) {
  updateOperatorSession(updateOperatorSessionInput: $input) {
    sessionNumber
    updated
  }
}
    `;
export type UpdateOperatorSessionMutationFn = Apollo.MutationFunction<UpdateOperatorSessionMutation, UpdateOperatorSessionMutationVariables>;

/**
 * __useUpdateOperatorSessionMutation__
 *
 * To run a mutation, you first call `useUpdateOperatorSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOperatorSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOperatorSessionMutation, { data, loading, error }] = useUpdateOperatorSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOperatorSessionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOperatorSessionMutation, UpdateOperatorSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOperatorSessionMutation, UpdateOperatorSessionMutationVariables>(UpdateOperatorSessionDocument, options);
      }
export type UpdateOperatorSessionMutationHookResult = ReturnType<typeof useUpdateOperatorSessionMutation>;
export type UpdateOperatorSessionMutationResult = Apollo.MutationResult<UpdateOperatorSessionMutation>;
export type UpdateOperatorSessionMutationOptions = Apollo.BaseMutationOptions<UpdateOperatorSessionMutation, UpdateOperatorSessionMutationVariables>;
export const UpdateUserAvatarDocument = gql`
    mutation updateUserAvatar($file: Upload!) {
  updateUserAvatar(file: $file) {
    user {
      ...UserFragment
    }
  }
}
    ${UserFragmentFragmentDoc}`;
export type UpdateUserAvatarMutationFn = Apollo.MutationFunction<UpdateUserAvatarMutation, UpdateUserAvatarMutationVariables>;

/**
 * __useUpdateUserAvatarMutation__
 *
 * To run a mutation, you first call `useUpdateUserAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAvatarMutation, { data, loading, error }] = useUpdateUserAvatarMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUpdateUserAvatarMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserAvatarMutation, UpdateUserAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserAvatarMutation, UpdateUserAvatarMutationVariables>(UpdateUserAvatarDocument, options);
      }
export type UpdateUserAvatarMutationHookResult = ReturnType<typeof useUpdateUserAvatarMutation>;
export type UpdateUserAvatarMutationResult = Apollo.MutationResult<UpdateUserAvatarMutation>;
export type UpdateUserAvatarMutationOptions = Apollo.BaseMutationOptions<UpdateUserAvatarMutation, UpdateUserAvatarMutationVariables>;
export const UpdateUserBackgroundDocument = gql`
    mutation updateUserBackground($file: Upload!) {
  updateUserBackground(file: $file) {
    user {
      ...UserFragment
    }
  }
}
    ${UserFragmentFragmentDoc}`;
export type UpdateUserBackgroundMutationFn = Apollo.MutationFunction<UpdateUserBackgroundMutation, UpdateUserBackgroundMutationVariables>;

/**
 * __useUpdateUserBackgroundMutation__
 *
 * To run a mutation, you first call `useUpdateUserBackgroundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserBackgroundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserBackgroundMutation, { data, loading, error }] = useUpdateUserBackgroundMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUpdateUserBackgroundMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserBackgroundMutation, UpdateUserBackgroundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserBackgroundMutation, UpdateUserBackgroundMutationVariables>(UpdateUserBackgroundDocument, options);
      }
export type UpdateUserBackgroundMutationHookResult = ReturnType<typeof useUpdateUserBackgroundMutation>;
export type UpdateUserBackgroundMutationResult = Apollo.MutationResult<UpdateUserBackgroundMutation>;
export type UpdateUserBackgroundMutationOptions = Apollo.BaseMutationOptions<UpdateUserBackgroundMutation, UpdateUserBackgroundMutationVariables>;
export const UpdateUserPasswordDocument = gql`
    mutation updateUserPassword($input: UpdateUserPasswordInput!) {
  updateUserPassword(updateUserPasswordInput: $input) {
    user {
      email
    }
  }
}
    `;
export type UpdateUserPasswordMutationFn = Apollo.MutationFunction<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>;

/**
 * __useUpdateUserPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPasswordMutation, { data, loading, error }] = useUpdateUserPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>(UpdateUserPasswordDocument, options);
      }
export type UpdateUserPasswordMutationHookResult = ReturnType<typeof useUpdateUserPasswordMutation>;
export type UpdateUserPasswordMutationResult = Apollo.MutationResult<UpdateUserPasswordMutation>;
export type UpdateUserPasswordMutationOptions = Apollo.BaseMutationOptions<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>;
export const VerifyLegalGuardianDocument = gql`
    mutation verifyLegalGuardian($input: VerifyLegalGuardianInput!) {
  verifyLegalGuardian(verifyLegalGuardianInput: $input) {
    user {
      ...UserFragment
    }
    verified
  }
}
    ${UserFragmentFragmentDoc}`;
export type VerifyLegalGuardianMutationFn = Apollo.MutationFunction<VerifyLegalGuardianMutation, VerifyLegalGuardianMutationVariables>;

/**
 * __useVerifyLegalGuardianMutation__
 *
 * To run a mutation, you first call `useVerifyLegalGuardianMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyLegalGuardianMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyLegalGuardianMutation, { data, loading, error }] = useVerifyLegalGuardianMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyLegalGuardianMutation(baseOptions?: Apollo.MutationHookOptions<VerifyLegalGuardianMutation, VerifyLegalGuardianMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyLegalGuardianMutation, VerifyLegalGuardianMutationVariables>(VerifyLegalGuardianDocument, options);
      }
export type VerifyLegalGuardianMutationHookResult = ReturnType<typeof useVerifyLegalGuardianMutation>;
export type VerifyLegalGuardianMutationResult = Apollo.MutationResult<VerifyLegalGuardianMutation>;
export type VerifyLegalGuardianMutationOptions = Apollo.BaseMutationOptions<VerifyLegalGuardianMutation, VerifyLegalGuardianMutationVariables>;
export const VerifyUserEmailDocument = gql`
    mutation verifyUserEmail($input: VerifyUserEmailInput!) {
  verifyUserEmail(verifyUserEmailInput: $input) {
    user {
      ...UserFragment
    }
    verified
  }
}
    ${UserFragmentFragmentDoc}`;
export type VerifyUserEmailMutationFn = Apollo.MutationFunction<VerifyUserEmailMutation, VerifyUserEmailMutationVariables>;

/**
 * __useVerifyUserEmailMutation__
 *
 * To run a mutation, you first call `useVerifyUserEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyUserEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyUserEmailMutation, { data, loading, error }] = useVerifyUserEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyUserEmailMutation(baseOptions?: Apollo.MutationHookOptions<VerifyUserEmailMutation, VerifyUserEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyUserEmailMutation, VerifyUserEmailMutationVariables>(VerifyUserEmailDocument, options);
      }
export type VerifyUserEmailMutationHookResult = ReturnType<typeof useVerifyUserEmailMutation>;
export type VerifyUserEmailMutationResult = Apollo.MutationResult<VerifyUserEmailMutation>;
export type VerifyUserEmailMutationOptions = Apollo.BaseMutationOptions<VerifyUserEmailMutation, VerifyUserEmailMutationVariables>;
export const CheckEmailExistDocument = gql`
    query checkEmailExist($input: CheckEmailExistInput!) {
  checkEmailExist(input: $input) {
    email
    exist
  }
}
    `;

/**
 * __useCheckEmailExistQuery__
 *
 * To run a query within a React component, call `useCheckEmailExistQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckEmailExistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckEmailExistQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckEmailExistQuery(baseOptions: Apollo.QueryHookOptions<CheckEmailExistQuery, CheckEmailExistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckEmailExistQuery, CheckEmailExistQueryVariables>(CheckEmailExistDocument, options);
      }
export function useCheckEmailExistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckEmailExistQuery, CheckEmailExistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckEmailExistQuery, CheckEmailExistQueryVariables>(CheckEmailExistDocument, options);
        }
export type CheckEmailExistQueryHookResult = ReturnType<typeof useCheckEmailExistQuery>;
export type CheckEmailExistLazyQueryHookResult = ReturnType<typeof useCheckEmailExistLazyQuery>;
export type CheckEmailExistQueryResult = Apollo.QueryResult<CheckEmailExistQuery, CheckEmailExistQueryVariables>;
export const CheckEmailTokenDocument = gql`
    query checkEmailToken($input: CheckEmailTokenInput!) {
  checkEmailToken(checkEmailTokenInput: $input) {
    user {
      ...UserFragment
    }
    type
    uuid
    sub
    tokenValid
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useCheckEmailTokenQuery__
 *
 * To run a query within a React component, call `useCheckEmailTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckEmailTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckEmailTokenQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckEmailTokenQuery(baseOptions: Apollo.QueryHookOptions<CheckEmailTokenQuery, CheckEmailTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckEmailTokenQuery, CheckEmailTokenQueryVariables>(CheckEmailTokenDocument, options);
      }
export function useCheckEmailTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckEmailTokenQuery, CheckEmailTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckEmailTokenQuery, CheckEmailTokenQueryVariables>(CheckEmailTokenDocument, options);
        }
export type CheckEmailTokenQueryHookResult = ReturnType<typeof useCheckEmailTokenQuery>;
export type CheckEmailTokenLazyQueryHookResult = ReturnType<typeof useCheckEmailTokenLazyQuery>;
export type CheckEmailTokenQueryResult = Apollo.QueryResult<CheckEmailTokenQuery, CheckEmailTokenQueryVariables>;
export const CheckUserNameExistDocument = gql`
    query checkUserNameExist($input: CheckUsernameExistInput!) {
  checkUserNameExist(input: $input) {
    username
    exist
  }
}
    `;

/**
 * __useCheckUserNameExistQuery__
 *
 * To run a query within a React component, call `useCheckUserNameExistQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckUserNameExistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckUserNameExistQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckUserNameExistQuery(baseOptions: Apollo.QueryHookOptions<CheckUserNameExistQuery, CheckUserNameExistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckUserNameExistQuery, CheckUserNameExistQueryVariables>(CheckUserNameExistDocument, options);
      }
export function useCheckUserNameExistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckUserNameExistQuery, CheckUserNameExistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckUserNameExistQuery, CheckUserNameExistQueryVariables>(CheckUserNameExistDocument, options);
        }
export type CheckUserNameExistQueryHookResult = ReturnType<typeof useCheckUserNameExistQuery>;
export type CheckUserNameExistLazyQueryHookResult = ReturnType<typeof useCheckUserNameExistLazyQuery>;
export type CheckUserNameExistQueryResult = Apollo.QueryResult<CheckUserNameExistQuery, CheckUserNameExistQueryVariables>;
export const ClubsDocument = gql`
    query clubs($name: String) {
  clubs(name: $name) {
    id
    logoUrl
    city
    country
    name
    street
  }
}
    `;

/**
 * __useClubsQuery__
 *
 * To run a query within a React component, call `useClubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClubsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClubsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useClubsQuery(baseOptions?: Apollo.QueryHookOptions<ClubsQuery, ClubsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClubsQuery, ClubsQueryVariables>(ClubsDocument, options);
      }
export function useClubsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClubsQuery, ClubsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClubsQuery, ClubsQueryVariables>(ClubsDocument, options);
        }
export type ClubsQueryHookResult = ReturnType<typeof useClubsQuery>;
export type ClubsLazyQueryHookResult = ReturnType<typeof useClubsLazyQuery>;
export type ClubsQueryResult = Apollo.QueryResult<ClubsQuery, ClubsQueryVariables>;
export const CompareDocument = gql`
    query compare($input: CompareInput!) {
  compare(compareInput: $input) {
    role
    type
    sessionNumber
    subFrom
    sub
    difference {
      type
      value
    }
    compareFrom {
      name
      sessionNumber
      avatar
      date
      subScores {
        type
        value
        rawData {
          name
          unit
          value
          stringValue
        }
      }
    }
    compareTo {
      name
      sessionNumber
      avatar
      date
      subScores {
        type
        value
        rawData {
          name
          unit
          value
          stringValue
        }
      }
    }
  }
}
    `;

/**
 * __useCompareQuery__
 *
 * To run a query within a React component, call `useCompareQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompareQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompareQuery(baseOptions: Apollo.QueryHookOptions<CompareQuery, CompareQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompareQuery, CompareQueryVariables>(CompareDocument, options);
      }
export function useCompareLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompareQuery, CompareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompareQuery, CompareQueryVariables>(CompareDocument, options);
        }
export type CompareQueryHookResult = ReturnType<typeof useCompareQuery>;
export type CompareLazyQueryHookResult = ReturnType<typeof useCompareLazyQuery>;
export type CompareQueryResult = Apollo.QueryResult<CompareQuery, CompareQueryVariables>;
export const FindComparisonOptionsDocument = gql`
    query findComparisonOptions($input: FindComparisonOptionsInput!) {
  findComparisonOptions(findComparisonOptionsInput: $input) {
    compareFrom {
      name
      avatar
      date
      sessionNumber
      value
    }
    team {
      id
      name
      logoUrl
      score
    }
    players {
      sessionNumber
      userId
      playerSessionId
      avatarUrl
      firstName
      lastName
      released
      score
    }
    previous {
      avatar
      date
      sessionNumber
      value
      released
    }
  }
}
    `;

/**
 * __useFindComparisonOptionsQuery__
 *
 * To run a query within a React component, call `useFindComparisonOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindComparisonOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindComparisonOptionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindComparisonOptionsQuery(baseOptions: Apollo.QueryHookOptions<FindComparisonOptionsQuery, FindComparisonOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindComparisonOptionsQuery, FindComparisonOptionsQueryVariables>(FindComparisonOptionsDocument, options);
      }
export function useFindComparisonOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindComparisonOptionsQuery, FindComparisonOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindComparisonOptionsQuery, FindComparisonOptionsQueryVariables>(FindComparisonOptionsDocument, options);
        }
export type FindComparisonOptionsQueryHookResult = ReturnType<typeof useFindComparisonOptionsQuery>;
export type FindComparisonOptionsLazyQueryHookResult = ReturnType<typeof useFindComparisonOptionsLazyQuery>;
export type FindComparisonOptionsQueryResult = Apollo.QueryResult<FindComparisonOptionsQuery, FindComparisonOptionsQueryVariables>;
export const FindEventPlayerDocument = gql`
    query findEventPlayer($eventNumber: Int!, $search: String!) {
  findEventPlayer(eventNumber: $eventNumber, search: $search) {
    player {
      ...UserFragment
    }
    inSession
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useFindEventPlayerQuery__
 *
 * To run a query within a React component, call `useFindEventPlayerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindEventPlayerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindEventPlayerQuery({
 *   variables: {
 *      eventNumber: // value for 'eventNumber'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useFindEventPlayerQuery(baseOptions: Apollo.QueryHookOptions<FindEventPlayerQuery, FindEventPlayerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindEventPlayerQuery, FindEventPlayerQueryVariables>(FindEventPlayerDocument, options);
      }
export function useFindEventPlayerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindEventPlayerQuery, FindEventPlayerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindEventPlayerQuery, FindEventPlayerQueryVariables>(FindEventPlayerDocument, options);
        }
export type FindEventPlayerQueryHookResult = ReturnType<typeof useFindEventPlayerQuery>;
export type FindEventPlayerLazyQueryHookResult = ReturnType<typeof useFindEventPlayerLazyQuery>;
export type FindEventPlayerQueryResult = Apollo.QueryResult<FindEventPlayerQuery, FindEventPlayerQueryVariables>;
export const FindEventTrainerDocument = gql`
    query findEventTrainer($eventNumber: Int!, $search: String!) {
  findEventTrainer(eventNumber: $eventNumber, search: $search) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useFindEventTrainerQuery__
 *
 * To run a query within a React component, call `useFindEventTrainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindEventTrainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindEventTrainerQuery({
 *   variables: {
 *      eventNumber: // value for 'eventNumber'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useFindEventTrainerQuery(baseOptions: Apollo.QueryHookOptions<FindEventTrainerQuery, FindEventTrainerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindEventTrainerQuery, FindEventTrainerQueryVariables>(FindEventTrainerDocument, options);
      }
export function useFindEventTrainerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindEventTrainerQuery, FindEventTrainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindEventTrainerQuery, FindEventTrainerQueryVariables>(FindEventTrainerDocument, options);
        }
export type FindEventTrainerQueryHookResult = ReturnType<typeof useFindEventTrainerQuery>;
export type FindEventTrainerLazyQueryHookResult = ReturnType<typeof useFindEventTrainerLazyQuery>;
export type FindEventTrainerQueryResult = Apollo.QueryResult<FindEventTrainerQuery, FindEventTrainerQueryVariables>;
export const FindOperatorSessionByIdDocument = gql`
    query findOperatorSessionById($sessionNumber: Int!) {
  findOperatorSessionById(sessionNumber: $sessionNumber) {
    sessionNumber
    ageGroup
    club {
      id
      name
    }
    fixedGoalkeepers
    sprintTest
    shotTest
    playersCount
    trainersCount
    matchesCount
    processed
    scored
    date
    ground {
      width
      height
      goalWidth
      goalHeight
    }
  }
}
    `;

/**
 * __useFindOperatorSessionByIdQuery__
 *
 * To run a query within a React component, call `useFindOperatorSessionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOperatorSessionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOperatorSessionByIdQuery({
 *   variables: {
 *      sessionNumber: // value for 'sessionNumber'
 *   },
 * });
 */
export function useFindOperatorSessionByIdQuery(baseOptions: Apollo.QueryHookOptions<FindOperatorSessionByIdQuery, FindOperatorSessionByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindOperatorSessionByIdQuery, FindOperatorSessionByIdQueryVariables>(FindOperatorSessionByIdDocument, options);
      }
export function useFindOperatorSessionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindOperatorSessionByIdQuery, FindOperatorSessionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindOperatorSessionByIdQuery, FindOperatorSessionByIdQueryVariables>(FindOperatorSessionByIdDocument, options);
        }
export type FindOperatorSessionByIdQueryHookResult = ReturnType<typeof useFindOperatorSessionByIdQuery>;
export type FindOperatorSessionByIdLazyQueryHookResult = ReturnType<typeof useFindOperatorSessionByIdLazyQuery>;
export type FindOperatorSessionByIdQueryResult = Apollo.QueryResult<FindOperatorSessionByIdQuery, FindOperatorSessionByIdQueryVariables>;
export const PlayerSessionDocument = gql`
    query playerSession($sessionNumber: Int!, $playerSessionId: Int!) {
  findPlayerScore(
    sessionNumber: $sessionNumber
    playerSessionId: $playerSessionId
  ) {
    ...PlayerScoreFragment
  }
}
    ${PlayerScoreFragmentFragmentDoc}`;

/**
 * __usePlayerSessionQuery__
 *
 * To run a query within a React component, call `usePlayerSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerSessionQuery({
 *   variables: {
 *      sessionNumber: // value for 'sessionNumber'
 *      playerSessionId: // value for 'playerSessionId'
 *   },
 * });
 */
export function usePlayerSessionQuery(baseOptions: Apollo.QueryHookOptions<PlayerSessionQuery, PlayerSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerSessionQuery, PlayerSessionQueryVariables>(PlayerSessionDocument, options);
      }
export function usePlayerSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerSessionQuery, PlayerSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerSessionQuery, PlayerSessionQueryVariables>(PlayerSessionDocument, options);
        }
export type PlayerSessionQueryHookResult = ReturnType<typeof usePlayerSessionQuery>;
export type PlayerSessionLazyQueryHookResult = ReturnType<typeof usePlayerSessionLazyQuery>;
export type PlayerSessionQueryResult = Apollo.QueryResult<PlayerSessionQuery, PlayerSessionQueryVariables>;
export const FindPlayerScoresByUserIdDocument = gql`
    query findPlayerScoresByUserId($userId: String!) {
  findPlayerScoresByUserId(userId: $userId) {
    ...PlayerScoreFragment
  }
}
    ${PlayerScoreFragmentFragmentDoc}`;

/**
 * __useFindPlayerScoresByUserIdQuery__
 *
 * To run a query within a React component, call `useFindPlayerScoresByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindPlayerScoresByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindPlayerScoresByUserIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFindPlayerScoresByUserIdQuery(baseOptions: Apollo.QueryHookOptions<FindPlayerScoresByUserIdQuery, FindPlayerScoresByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindPlayerScoresByUserIdQuery, FindPlayerScoresByUserIdQueryVariables>(FindPlayerScoresByUserIdDocument, options);
      }
export function useFindPlayerScoresByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindPlayerScoresByUserIdQuery, FindPlayerScoresByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindPlayerScoresByUserIdQuery, FindPlayerScoresByUserIdQueryVariables>(FindPlayerScoresByUserIdDocument, options);
        }
export type FindPlayerScoresByUserIdQueryHookResult = ReturnType<typeof useFindPlayerScoresByUserIdQuery>;
export type FindPlayerScoresByUserIdLazyQueryHookResult = ReturnType<typeof useFindPlayerScoresByUserIdLazyQuery>;
export type FindPlayerScoresByUserIdQueryResult = Apollo.QueryResult<FindPlayerScoresByUserIdQuery, FindPlayerScoresByUserIdQueryVariables>;
export const FindPlayersDocument = gql`
    query findPlayers($sessionNumber: Int!) {
  findPlayers(sessionNumber: $sessionNumber) {
    sessionNumber
    playerSessionId
    score
    released
    userId
    avatarUrl
    firstName
    lastName
  }
}
    `;

/**
 * __useFindPlayersQuery__
 *
 * To run a query within a React component, call `useFindPlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindPlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindPlayersQuery({
 *   variables: {
 *      sessionNumber: // value for 'sessionNumber'
 *   },
 * });
 */
export function useFindPlayersQuery(baseOptions: Apollo.QueryHookOptions<FindPlayersQuery, FindPlayersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindPlayersQuery, FindPlayersQueryVariables>(FindPlayersDocument, options);
      }
export function useFindPlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindPlayersQuery, FindPlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindPlayersQuery, FindPlayersQueryVariables>(FindPlayersDocument, options);
        }
export type FindPlayersQueryHookResult = ReturnType<typeof useFindPlayersQuery>;
export type FindPlayersLazyQueryHookResult = ReturnType<typeof useFindPlayersLazyQuery>;
export type FindPlayersQueryResult = Apollo.QueryResult<FindPlayersQuery, FindPlayersQueryVariables>;
export const FindVideoDocument = gql`
    query findVideo($id: String!, $sessionNumber: Int!, $playerSessionId: Int) {
  findVideo(
    id: $id
    sessionNumber: $sessionNumber
    playerSessionId: $playerSessionId
  ) {
    id
    url
    cookies
  }
}
    `;

/**
 * __useFindVideoQuery__
 *
 * To run a query within a React component, call `useFindVideoQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindVideoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindVideoQuery({
 *   variables: {
 *      id: // value for 'id'
 *      sessionNumber: // value for 'sessionNumber'
 *      playerSessionId: // value for 'playerSessionId'
 *   },
 * });
 */
export function useFindVideoQuery(baseOptions: Apollo.QueryHookOptions<FindVideoQuery, FindVideoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindVideoQuery, FindVideoQueryVariables>(FindVideoDocument, options);
      }
export function useFindVideoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindVideoQuery, FindVideoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindVideoQuery, FindVideoQueryVariables>(FindVideoDocument, options);
        }
export type FindVideoQueryHookResult = ReturnType<typeof useFindVideoQuery>;
export type FindVideoLazyQueryHookResult = ReturnType<typeof useFindVideoLazyQuery>;
export type FindVideoQueryResult = Apollo.QueryResult<FindVideoQuery, FindVideoQueryVariables>;
export const FindVideosDocument = gql`
    query findVideos($role: UserRole!) {
  findVideos(role: $role) {
    date
    sessionNumber
    playerSessionId
    videos {
      id
      thumb
      match
    }
  }
}
    `;

/**
 * __useFindVideosQuery__
 *
 * To run a query within a React component, call `useFindVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindVideosQuery({
 *   variables: {
 *      role: // value for 'role'
 *   },
 * });
 */
export function useFindVideosQuery(baseOptions: Apollo.QueryHookOptions<FindVideosQuery, FindVideosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindVideosQuery, FindVideosQueryVariables>(FindVideosDocument, options);
      }
export function useFindVideosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindVideosQuery, FindVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindVideosQuery, FindVideosQueryVariables>(FindVideosDocument, options);
        }
export type FindVideosQueryHookResult = ReturnType<typeof useFindVideosQuery>;
export type FindVideosLazyQueryHookResult = ReturnType<typeof useFindVideosLazyQuery>;
export type FindVideosQueryResult = Apollo.QueryResult<FindVideosQuery, FindVideosQueryVariables>;
export const GetEventDocument = gql`
    query getEvent($eventNumber: Int!) {
  getEvent(eventNumber: $eventNumber) {
    eventNumber
    name
    club {
      id
      name
    }
    players {
      ...UserFragment
    }
    trainers {
      ...UserFragment
    }
    sessions {
      ...PartialOperatorSessionFragment
    }
    start
    end
    fixedGoalKeepers
    shotTest
    sprintTest
    externalSources
  }
}
    ${UserFragmentFragmentDoc}
${PartialOperatorSessionFragmentFragmentDoc}`;

/**
 * __useGetEventQuery__
 *
 * To run a query within a React component, call `useGetEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventQuery({
 *   variables: {
 *      eventNumber: // value for 'eventNumber'
 *   },
 * });
 */
export function useGetEventQuery(baseOptions: Apollo.QueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, options);
      }
export function useGetEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, options);
        }
export type GetEventQueryHookResult = ReturnType<typeof useGetEventQuery>;
export type GetEventLazyQueryHookResult = ReturnType<typeof useGetEventLazyQuery>;
export type GetEventQueryResult = Apollo.QueryResult<GetEventQuery, GetEventQueryVariables>;
export const GetEventSessionDocument = gql`
    query getEventSession($eventNumber: Int!, $sessionNumber: Int!) {
  getEventSession(eventNumber: $eventNumber, sessionNumber: $sessionNumber) {
    ...OperatorSessionFragment
  }
}
    ${OperatorSessionFragmentFragmentDoc}`;

/**
 * __useGetEventSessionQuery__
 *
 * To run a query within a React component, call `useGetEventSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventSessionQuery({
 *   variables: {
 *      eventNumber: // value for 'eventNumber'
 *      sessionNumber: // value for 'sessionNumber'
 *   },
 * });
 */
export function useGetEventSessionQuery(baseOptions: Apollo.QueryHookOptions<GetEventSessionQuery, GetEventSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventSessionQuery, GetEventSessionQueryVariables>(GetEventSessionDocument, options);
      }
export function useGetEventSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventSessionQuery, GetEventSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventSessionQuery, GetEventSessionQueryVariables>(GetEventSessionDocument, options);
        }
export type GetEventSessionQueryHookResult = ReturnType<typeof useGetEventSessionQuery>;
export type GetEventSessionLazyQueryHookResult = ReturnType<typeof useGetEventSessionLazyQuery>;
export type GetEventSessionQueryResult = Apollo.QueryResult<GetEventSessionQuery, GetEventSessionQueryVariables>;
export const ListEventSessionsDocument = gql`
    query listEventSessions($eventNumber: Int!) {
  listEventSessions(eventNumber: $eventNumber) {
    ...OperatorSessionFragment
  }
}
    ${OperatorSessionFragmentFragmentDoc}`;

/**
 * __useListEventSessionsQuery__
 *
 * To run a query within a React component, call `useListEventSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEventSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEventSessionsQuery({
 *   variables: {
 *      eventNumber: // value for 'eventNumber'
 *   },
 * });
 */
export function useListEventSessionsQuery(baseOptions: Apollo.QueryHookOptions<ListEventSessionsQuery, ListEventSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListEventSessionsQuery, ListEventSessionsQueryVariables>(ListEventSessionsDocument, options);
      }
export function useListEventSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListEventSessionsQuery, ListEventSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListEventSessionsQuery, ListEventSessionsQueryVariables>(ListEventSessionsDocument, options);
        }
export type ListEventSessionsQueryHookResult = ReturnType<typeof useListEventSessionsQuery>;
export type ListEventSessionsLazyQueryHookResult = ReturnType<typeof useListEventSessionsLazyQuery>;
export type ListEventSessionsQueryResult = Apollo.QueryResult<ListEventSessionsQuery, ListEventSessionsQueryVariables>;
export const ListEventsDocument = gql`
    query listEvents {
  listEvents {
    eventNumber
    name
    club {
      id
      name
    }
    players {
      ...UserFragment
    }
    trainers {
      ...UserFragment
    }
    sessions {
      sessionNumber
    }
    start
    end
    fixedGoalKeepers
    shotTest
    sprintTest
    externalSources
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useListEventsQuery__
 *
 * To run a query within a React component, call `useListEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListEventsQuery(baseOptions?: Apollo.QueryHookOptions<ListEventsQuery, ListEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListEventsQuery, ListEventsQueryVariables>(ListEventsDocument, options);
      }
export function useListEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListEventsQuery, ListEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListEventsQuery, ListEventsQueryVariables>(ListEventsDocument, options);
        }
export type ListEventsQueryHookResult = ReturnType<typeof useListEventsQuery>;
export type ListEventsLazyQueryHookResult = ReturnType<typeof useListEventsLazyQuery>;
export type ListEventsQueryResult = Apollo.QueryResult<ListEventsQuery, ListEventsQueryVariables>;
export const GetTrainingVideosDocument = gql`
    query getTrainingVideos($sessionNumber: Int!, $playerSessionId: Int!) {
  getTrainingVideos(
    sessionNumber: $sessionNumber
    playerSessionId: $playerSessionId
  ) {
    sessionNumber
    userId
    playerSessionId
    sessionNumber
    type
    trainingsVideos {
      texts {
        title
        subtext
      }
      uuid
      thumbnailUrl
      previewUrl
    }
  }
}
    `;

/**
 * __useGetTrainingVideosQuery__
 *
 * To run a query within a React component, call `useGetTrainingVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrainingVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrainingVideosQuery({
 *   variables: {
 *      sessionNumber: // value for 'sessionNumber'
 *      playerSessionId: // value for 'playerSessionId'
 *   },
 * });
 */
export function useGetTrainingVideosQuery(baseOptions: Apollo.QueryHookOptions<GetTrainingVideosQuery, GetTrainingVideosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrainingVideosQuery, GetTrainingVideosQueryVariables>(GetTrainingVideosDocument, options);
      }
export function useGetTrainingVideosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrainingVideosQuery, GetTrainingVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrainingVideosQuery, GetTrainingVideosQueryVariables>(GetTrainingVideosDocument, options);
        }
export type GetTrainingVideosQueryHookResult = ReturnType<typeof useGetTrainingVideosQuery>;
export type GetTrainingVideosLazyQueryHookResult = ReturnType<typeof useGetTrainingVideosLazyQuery>;
export type GetTrainingVideosQueryResult = Apollo.QueryResult<GetTrainingVideosQuery, GetTrainingVideosQueryVariables>;
export const NotificationsDocument = gql`
    query notifications {
  notifications {
    minAppVersion
    unreadCount
    notificationList {
      type
      parameters {
        key
        value
      }
    }
  }
}
    `;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
      }
export function useNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsLazyQueryHookResult = ReturnType<typeof useNotificationsLazyQuery>;
export type NotificationsQueryResult = Apollo.QueryResult<NotificationsQuery, NotificationsQueryVariables>;
export const OperatorSessionsDocument = gql`
    query operatorSessions {
  operatorSessions {
    sessionNumber
    ageGroup
    club {
      id
      name
    }
    fixedGoalkeepers
    sprintTest
    shotTest
    playersCount
    trainersCount
    matchesCount
    processed
    scored
    date
    allVideosUploaded
    videosUploaded
    ground {
      width
      height
      goalWidth
      goalHeight
    }
  }
}
    `;

/**
 * __useOperatorSessionsQuery__
 *
 * To run a query within a React component, call `useOperatorSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorSessionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOperatorSessionsQuery(baseOptions?: Apollo.QueryHookOptions<OperatorSessionsQuery, OperatorSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorSessionsQuery, OperatorSessionsQueryVariables>(OperatorSessionsDocument, options);
      }
export function useOperatorSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorSessionsQuery, OperatorSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorSessionsQuery, OperatorSessionsQueryVariables>(OperatorSessionsDocument, options);
        }
export type OperatorSessionsQueryHookResult = ReturnType<typeof useOperatorSessionsQuery>;
export type OperatorSessionsLazyQueryHookResult = ReturnType<typeof useOperatorSessionsLazyQuery>;
export type OperatorSessionsQueryResult = Apollo.QueryResult<OperatorSessionsQuery, OperatorSessionsQueryVariables>;
export const PlayerSessionsDocument = gql`
    query playerSessions {
  playerScores {
    ...PlayerScoreFragment
  }
}
    ${PlayerScoreFragmentFragmentDoc}`;

/**
 * __usePlayerSessionsQuery__
 *
 * To run a query within a React component, call `usePlayerSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerSessionsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlayerSessionsQuery(baseOptions?: Apollo.QueryHookOptions<PlayerSessionsQuery, PlayerSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerSessionsQuery, PlayerSessionsQueryVariables>(PlayerSessionsDocument, options);
      }
export function usePlayerSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerSessionsQuery, PlayerSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerSessionsQuery, PlayerSessionsQueryVariables>(PlayerSessionsDocument, options);
        }
export type PlayerSessionsQueryHookResult = ReturnType<typeof usePlayerSessionsQuery>;
export type PlayerSessionsLazyQueryHookResult = ReturnType<typeof usePlayerSessionsLazyQuery>;
export type PlayerSessionsQueryResult = Apollo.QueryResult<PlayerSessionsQuery, PlayerSessionsQueryVariables>;
export const SearchExternalSourcesDocument = gql`
    query searchExternalSources($externalSource: String!, $roles: [String!]!) {
  searchUsers(externalSource: $externalSource, roles: $roles) {
    externalSource
  }
}
    `;

/**
 * __useSearchExternalSourcesQuery__
 *
 * To run a query within a React component, call `useSearchExternalSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchExternalSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchExternalSourcesQuery({
 *   variables: {
 *      externalSource: // value for 'externalSource'
 *      roles: // value for 'roles'
 *   },
 * });
 */
export function useSearchExternalSourcesQuery(baseOptions: Apollo.QueryHookOptions<SearchExternalSourcesQuery, SearchExternalSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchExternalSourcesQuery, SearchExternalSourcesQueryVariables>(SearchExternalSourcesDocument, options);
      }
export function useSearchExternalSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchExternalSourcesQuery, SearchExternalSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchExternalSourcesQuery, SearchExternalSourcesQueryVariables>(SearchExternalSourcesDocument, options);
        }
export type SearchExternalSourcesQueryHookResult = ReturnType<typeof useSearchExternalSourcesQuery>;
export type SearchExternalSourcesLazyQueryHookResult = ReturnType<typeof useSearchExternalSourcesLazyQuery>;
export type SearchExternalSourcesQueryResult = Apollo.QueryResult<SearchExternalSourcesQuery, SearchExternalSourcesQueryVariables>;
export const SearchPlayersDocument = gql`
    query searchPlayers($externalSource: String!) {
  searchPlayers(externalSource: $externalSource) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useSearchPlayersQuery__
 *
 * To run a query within a React component, call `useSearchPlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPlayersQuery({
 *   variables: {
 *      externalSource: // value for 'externalSource'
 *   },
 * });
 */
export function useSearchPlayersQuery(baseOptions: Apollo.QueryHookOptions<SearchPlayersQuery, SearchPlayersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPlayersQuery, SearchPlayersQueryVariables>(SearchPlayersDocument, options);
      }
export function useSearchPlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPlayersQuery, SearchPlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPlayersQuery, SearchPlayersQueryVariables>(SearchPlayersDocument, options);
        }
export type SearchPlayersQueryHookResult = ReturnType<typeof useSearchPlayersQuery>;
export type SearchPlayersLazyQueryHookResult = ReturnType<typeof useSearchPlayersLazyQuery>;
export type SearchPlayersQueryResult = Apollo.QueryResult<SearchPlayersQuery, SearchPlayersQueryVariables>;
export const SearchTrainersDocument = gql`
    query searchTrainers($externalSource: String!) {
  searchTrainers(externalSource: $externalSource) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useSearchTrainersQuery__
 *
 * To run a query within a React component, call `useSearchTrainersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTrainersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTrainersQuery({
 *   variables: {
 *      externalSource: // value for 'externalSource'
 *   },
 * });
 */
export function useSearchTrainersQuery(baseOptions: Apollo.QueryHookOptions<SearchTrainersQuery, SearchTrainersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchTrainersQuery, SearchTrainersQueryVariables>(SearchTrainersDocument, options);
      }
export function useSearchTrainersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchTrainersQuery, SearchTrainersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchTrainersQuery, SearchTrainersQueryVariables>(SearchTrainersDocument, options);
        }
export type SearchTrainersQueryHookResult = ReturnType<typeof useSearchTrainersQuery>;
export type SearchTrainersLazyQueryHookResult = ReturnType<typeof useSearchTrainersLazyQuery>;
export type SearchTrainersQueryResult = Apollo.QueryResult<SearchTrainersQuery, SearchTrainersQueryVariables>;
export const SearchUsersDocument = gql`
    query searchUsers($externalSource: String!, $roles: [String!]!) {
  searchUsers(externalSource: $externalSource, roles: $roles) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useSearchUsersQuery__
 *
 * To run a query within a React component, call `useSearchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersQuery({
 *   variables: {
 *      externalSource: // value for 'externalSource'
 *      roles: // value for 'roles'
 *   },
 * });
 */
export function useSearchUsersQuery(baseOptions: Apollo.QueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
      }
export function useSearchUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
export type SearchUsersQueryHookResult = ReturnType<typeof useSearchUsersQuery>;
export type SearchUsersLazyQueryHookResult = ReturnType<typeof useSearchUsersLazyQuery>;
export type SearchUsersQueryResult = Apollo.QueryResult<SearchUsersQuery, SearchUsersQueryVariables>;
export const TrainerSessionsDocument = gql`
    query trainerSessions {
  sessions {
    ...TrainerSessionFragment
  }
}
    ${TrainerSessionFragmentFragmentDoc}`;

/**
 * __useTrainerSessionsQuery__
 *
 * To run a query within a React component, call `useTrainerSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainerSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainerSessionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTrainerSessionsQuery(baseOptions?: Apollo.QueryHookOptions<TrainerSessionsQuery, TrainerSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainerSessionsQuery, TrainerSessionsQueryVariables>(TrainerSessionsDocument, options);
      }
export function useTrainerSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainerSessionsQuery, TrainerSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainerSessionsQuery, TrainerSessionsQueryVariables>(TrainerSessionsDocument, options);
        }
export type TrainerSessionsQueryHookResult = ReturnType<typeof useTrainerSessionsQuery>;
export type TrainerSessionsLazyQueryHookResult = ReturnType<typeof useTrainerSessionsLazyQuery>;
export type TrainerSessionsQueryResult = Apollo.QueryResult<TrainerSessionsQuery, TrainerSessionsQueryVariables>;
export const UserDocument = gql`
    query user {
  user {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserQuery(baseOptions?: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const ValidateCodeDocument = gql`
    query validateCode($code: String!) {
  validateCode(code: $code) {
    code
    valid
  }
}
    `;

/**
 * __useValidateCodeQuery__
 *
 * To run a query within a React component, call `useValidateCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useValidateCodeQuery(baseOptions: Apollo.QueryHookOptions<ValidateCodeQuery, ValidateCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateCodeQuery, ValidateCodeQueryVariables>(ValidateCodeDocument, options);
      }
export function useValidateCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateCodeQuery, ValidateCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateCodeQuery, ValidateCodeQueryVariables>(ValidateCodeDocument, options);
        }
export type ValidateCodeQueryHookResult = ReturnType<typeof useValidateCodeQuery>;
export type ValidateCodeLazyQueryHookResult = ReturnType<typeof useValidateCodeLazyQuery>;
export type ValidateCodeQueryResult = Apollo.QueryResult<ValidateCodeQuery, ValidateCodeQueryVariables>;
export const ValidateEmailDocument = gql`
    query validateEmail($input: ValidateEmailInput!) {
  validateEmail(validateEmailInput: $input) {
    email
    valid
  }
}
    `;

/**
 * __useValidateEmailQuery__
 *
 * To run a query within a React component, call `useValidateEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateEmailQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateEmailQuery(baseOptions: Apollo.QueryHookOptions<ValidateEmailQuery, ValidateEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateEmailQuery, ValidateEmailQueryVariables>(ValidateEmailDocument, options);
      }
export function useValidateEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateEmailQuery, ValidateEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateEmailQuery, ValidateEmailQueryVariables>(ValidateEmailDocument, options);
        }
export type ValidateEmailQueryHookResult = ReturnType<typeof useValidateEmailQuery>;
export type ValidateEmailLazyQueryHookResult = ReturnType<typeof useValidateEmailLazyQuery>;
export type ValidateEmailQueryResult = Apollo.QueryResult<ValidateEmailQuery, ValidateEmailQueryVariables>;
export const WatchComparisonsDocument = gql`
    query watchComparisons($role: UserRole!) {
  watchComparisons(role: $role) {
    id
    role
    skill
    type
    sessionNumber
    subFrom
    sub
    compareFrom {
      name
      sessionNumber
      avatar
      date
      value
    }
    compareTo {
      name
      sessionNumber
      avatar
      date
      value
    }
  }
}
    `;

/**
 * __useWatchComparisonsQuery__
 *
 * To run a query within a React component, call `useWatchComparisonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWatchComparisonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchComparisonsQuery({
 *   variables: {
 *      role: // value for 'role'
 *   },
 * });
 */
export function useWatchComparisonsQuery(baseOptions: Apollo.QueryHookOptions<WatchComparisonsQuery, WatchComparisonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WatchComparisonsQuery, WatchComparisonsQueryVariables>(WatchComparisonsDocument, options);
      }
export function useWatchComparisonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WatchComparisonsQuery, WatchComparisonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WatchComparisonsQuery, WatchComparisonsQueryVariables>(WatchComparisonsDocument, options);
        }
export type WatchComparisonsQueryHookResult = ReturnType<typeof useWatchComparisonsQuery>;
export type WatchComparisonsLazyQueryHookResult = ReturnType<typeof useWatchComparisonsLazyQuery>;
export type WatchComparisonsQueryResult = Apollo.QueryResult<WatchComparisonsQuery, WatchComparisonsQueryVariables>;